(() => {
  function t(t, e) {
    const r = String(e || "")
        .trim()
        .toUpperCase()
        .replace(/[^A-Z]/g, ""),
      n = /^[A-Z]{3}$/.test(r) ? r : "GBP";
    try {
      return new Intl.NumberFormat(t, {
        style: "currency",
        currency: n,
        currencyDisplay: "narrowSymbol",
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    } catch (t) {
      const e = { GBP: "GBP ", USD: "$", EUR: "EUR " }[n] || `${n} `;
      return {
        format(t) {
          const r = Number(t || 0);
          return `${e}${r.toFixed(2)}`;
        },
      };
    }
  }
  function e(t, e) {
    const r = Number(e || 0) / 100;
    return t.format(r);
  }
  function r(t = document) {
    Array.from(t.querySelectorAll("[data-content-tabs]")).forEach((t) => {
      const e = Array.from(t.querySelectorAll("[data-tab-trigger]")),
        r = Array.from(t.querySelectorAll("[data-tab-panel]"));
      function n(t, n) {
        const a = t.getAttribute("aria-controls");
        (e.forEach((e) => {
          const r = e === t;
          (e.classList.toggle("is-active", r),
            e.setAttribute("aria-selected", String(r)),
            e.setAttribute("tabindex", r ? "0" : "-1"));
        }),
          r.forEach((t) => {
            const e = t.id === a;
            (t.classList.toggle("is-active", e),
              e ? t.removeAttribute("hidden") : t.setAttribute("hidden", ""));
          }),
          n && t.focus());
      }
      0 !== e.length &&
        0 !== r.length &&
        (e.forEach((t, r) => {
          (t.addEventListener("click", () => {
            n(t, !1);
          }),
            t.addEventListener("keydown", (a) => {
              let o = r;
              if ("ArrowRight" === a.key) o = (r + 1) % e.length;
              else if ("ArrowLeft" === a.key) o = (r - 1 + e.length) % e.length;
              else if ("Home" === a.key) o = 0;
              else {
                if ("End" !== a.key)
                  return "Enter" === a.key || " " === a.key
                    ? void n(t, !1)
                    : void 0;
                o = e.length - 1;
              }
              (a.preventDefault(), n(e[o], !0));
            }));
        }),
        n(
          e.find((t) => t.classList.contains("is-active")) ||
            e.find((t) => "true" === t.getAttribute("aria-selected")) ||
            e[0],
          !1,
        ));
    });
  }
  function n(t = document) {
    const e = t.querySelector("#chat-msgs"),
      r = t.querySelector("#chat-input"),
      n = t.querySelector("#chat-send"),
      a = Array.from(t.querySelectorAll("[data-suggest]")),
      o = t.querySelector("[data-product-section]"),
      i = o ? o.dataset.chatWebhook : "";
    function s(t, r) {
      const n = document.createElement("div");
      ((n.className = `chat-msg chat-msg-${r}`),
        (n.textContent = t),
        e.append(n),
        (e.scrollTop = e.scrollHeight));
    }
    function c(t) {
      if (!t) return "";
      if ("string" == typeof t) return t.trim();
      if (Array.isArray(t)) {
        for (const e of t) {
          const t = c(e);
          if (t) return t;
        }
        return "";
      }
      if ("object" == typeof t) {
        const e = [
          "reply",
          "message",
          "text",
          "output",
          "response",
          "answer",
          "content",
        ];
        for (const r of e)
          if (r in t) {
            const e = c(t[r]);
            if (e) return e;
          }
        for (const e of Object.values(t)) {
          const t = c(e);
          if (t) return t;
        }
      }
      return "";
    }
    async function l(t) {
      const n = String(t || "").trim();
      if (!n) return;
      (s(n, "user"), r && (r.value = ""));
      const a = (function () {
        const t = document.createElement("div");
        return (
          (t.className = "chat-msg chat-msg-bot chat-msg-typing"),
          t.setAttribute("aria-label", "Sleep expert is typing"),
          (t.innerHTML =
            '<span class="chat-dot"></span><span class="chat-dot"></span><span class="chat-dot"></span>'),
          e.append(t),
          (e.scrollTop = e.scrollHeight),
          t
        );
      })();
      if (!i)
        return (
          a.remove(),
          void s(
            "Emma is not connected right now. Please call 01924 806426 or try again shortly.",
            "bot",
          )
        );
      try {
        const t = await fetch(i, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            message: n,
            timestamp: new Date().toISOString(),
            sessionId: d(),
            product: {
              title: (o && o.dataset.productTitle) || "",
              type: (o && o.dataset.productTypeName) || "",
              url: (o && (o.dataset.productUrl || "")) || location.pathname,
              variantId:
                (document.querySelector('input[name="id"]') || {}).value || "",
            },
          }),
        });
        if (!t.ok) throw new Error(`Webhook returned ${t.status}`);
        {
          const e = await t.text();
          a.remove();
          let r = "";
          if (e)
            try {
              r = c(JSON.parse(e));
            } catch {
              r = e.trim();
            }
          if (!r)
            return void s(
              "No reply came back from the assistant. Please try again.",
              "bot",
            );
          s(r, "bot");
        }
      } catch (t) {
        (a.remove(),
          s(
            "Sorry, Emma is not connected right now. Please call 01924 806426 or try again shortly.",
            "bot",
          ),
          console.error("Chat webhook error:", t));
      }
    }
    function d() {
      let t = sessionStorage.getItem("chat_session_id");
      return (
        t ||
          ((t = "session_" + Math.random().toString(36).substr(2, 9)),
          sessionStorage.setItem("chat_session_id", t)),
        t
      );
    }
    e &&
      (a.forEach((t) => {
        t.addEventListener("click", () => {
          l(t.dataset.suggest);
        });
      }),
      n &&
        n.addEventListener("click", () => {
          l(r ? r.value : "");
        }),
      r &&
        r.addEventListener("keydown", (t) => {
          "Enter" === t.key && (t.preventDefault(), l(r.value));
        }));
  }
  function a(t = document) {
    const e = Array.from(t.querySelectorAll(".afu"));
    if (0 === e.length) return;
    if (void 0 === window.IntersectionObserver)
      return void e.forEach((t) => {
        t.classList.add("is-visible");
      });
    const r = new IntersectionObserver(
      (t) => {
        t.forEach((t) => {
          t.isIntersecting &&
            (t.target.classList.add("is-visible"), r.unobserve(t.target));
        });
      },
      { threshold: 0.12 },
    );
    e.forEach((t) => {
      r.observe(t);
    });
  }
  function o(t) {
    return (function () {
      try {
        const t = localStorage.getItem("shopify_wishlist");
        return t ? JSON.parse(t) : [];
      } catch {
        return [];
      }
    })().includes(String(t));
  }
  function i(t, e) {
    ((window.Wishlist ? window.Wishlist.isIn(e) : o(e))
      ? (t.classList.add("is-active"), t.setAttribute("aria-pressed", "true"))
      : (t.classList.remove("is-active"),
        t.setAttribute("aria-pressed", "false")),
      (function (t, e) {
        const r = window.Wishlist ? window.Wishlist.isIn(e) : o(e),
          n = t.querySelector(".gallery-wish-tooltip");
        n && (n.textContent = r ? "Remove from Wishlist" : "Add to Wishlist");
        const a = t.querySelector(".btn-wishlist-label");
        a && (a.textContent = r ? "Remove from Wishlist" : "Save to Wishlist");
      })(t, e));
  }
  function s(o) {
    const l = o.querySelector("[data-product-form]"),
      d = o.querySelector("[data-product-json]"),
      u = o.querySelector("[data-product-handle]"),
      f = o.querySelector("[data-product-gallery-groups]");
    if (!l || !d) return;
    let m,
      p = null,
      g = {},
      h = -1;
    try {
      m = JSON.parse(d.textContent);
    } catch (t) {
      return;
    }
    if (!Array.isArray(m) || 0 === m.length) return;
    if (u)
      try {
        p = JSON.parse(u.textContent);
      } catch (t) {
        p = null;
      }
    if (f)
      try {
        const t = JSON.parse(f.textContent);
        t &&
          "object" == typeof t &&
          ((g = t.groups || {}), (h = Number(t.colorOptionIndex)));
      } catch (t) {
        ((g = {}), (h = -1));
      }
    const b = l.querySelector('input[name="id"]');
    if (!b) return;
    const y = t(
        document.documentElement.lang || "en-US",
        o.dataset.currency || "USD",
      ),
      v = "true" === o.dataset.useServerOptionNavigation,
      S = Number(o.dataset.variantsLoadedCount || m.length || 0),
      w = Number(o.dataset.variantsTotalCount || S || m.length || 0),
      A = o.dataset.sectionId || "";
    let q = null;
    const E = 250;
    let L = S < E && S === w,
      x = null,
      k = 0;
    const C = (function (t) {
      const e = t.querySelector("[data-gallery-main-image]"),
        r = Array.from(t.querySelectorAll("[data-gallery-thumb]")),
        n = Array.from(document.querySelectorAll("[data-modal-thumb]")),
        a = t.querySelector("[data-gallery-zoom]"),
        o = document.querySelector("[data-gallery-modal]"),
        i = t.querySelector("[data-thumbs-viewport]"),
        s = t.querySelector("[data-thumbs-track]"),
        c = t.querySelector("[data-thumbs-prev]"),
        l = t.querySelector("[data-thumbs-next]"),
        d = t.querySelector("[data-gallery-main-prev]"),
        u = t.querySelector("[data-gallery-main-next]");
      if (!e || 0 === r.length)
        return { setMediaId() {}, setVisibleMediaIds() {} };
      let f = 0,
        m = !1,
        p = 0;
      function g() {
        return r.filter((t) => !t.hidden);
      }
      function h() {
        return g().map((t, e) => ({
          src: t.dataset.zoomSrc || t.dataset.imageSrc,
          alt: t.dataset.imageAlt || "",
          mediaId: String(t.dataset.mediaId || ""),
          index: e,
        }));
      }
      function b() {
        const t = g().length <= 1;
        (d && (d.disabled = t), u && (u.disabled = t));
      }
      function hydrateVisibleThumbs() {
        r.concat(n).forEach((thumb) => {
          if (!thumb || thumb.hidden) return;
          const image = thumb.querySelector("[data-gallery-lazy-thumb]");
          if (!image || image.dataset.thumbLoaded === "true") return;
          const srcset = image.dataset.thumbSrcset || "";
          const src = image.dataset.thumbSrc || "";
          if (srcset) image.srcset = srcset;
          if (src) image.src = src;
          if (src || srcset) image.dataset.thumbLoaded = "true";
        });
        document.dispatchEvent(new CustomEvent("gallery:thumbs-updated"));
      }
      function y() {
        if (!i || !c || !l) return;
        if (g().length <= 1) return ((c.disabled = !0), void (l.disabled = !0));
        const t = i.offsetWidth,
          e = s.scrollWidth - t;
        ((c.disabled = p <= 0), (l.disabled = p >= e - 5));
      }
      function v() {
        if (!s) return 10;
        const t = window.getComputedStyle(s);
        return parseFloat(t.gap) || 10;
      }
      function S(t) {
        if (!i || !s) return;
        const e = g();
        if (0 === e.length) return;
        const r = v(),
          n = e[0].offsetWidth + r,
          a = i.offsetWidth,
          o = s.scrollWidth - a,
          c = 3 * n;
        ((p = "next" === t ? Math.min(p + c, o) : Math.max(p - c, 0)),
          (s.style.transform = `translateX(-${p}px)`),
          y());
      }
      function w(t) {
        if (!i || !s) return;
        const e = g()[t];
        if (!e) return;
        const r = v(),
          n = e.offsetWidth + r,
          a = t * n,
          o = i.offsetWidth,
          c = s.scrollWidth - o,
          l = Math.max(0, Math.min(a - o / 2 + n / 2, c));
        ((p = l), (s.style.transform = `translateX(-${p}px)`), y());
      }
      let A = 0,
        q = 0,
        E = !1;
      const zoomButton = a;
      function L() {
        const t = A - q;
        Math.abs(t) > 50 && S(t > 0 ? "next" : "prev");
      }
      function x(t) {
        const e = g();
        if (0 === e.length) return;
        const r = e[(f + t + e.length) % e.length];
        r && k(r);
      }
      function k(t, n = !1) {
        const a = g().indexOf(t);
        (-1 !== a && ((f = a), w(a)),
          r.forEach((e) => {
            const r = e === t;
            (e.classList.toggle("is-active", r),
              e.setAttribute("aria-selected", String(r)));
          }));
        const galleryRoot = n && n.querySelector ? n : t.closest("[data-gallery]");
        zoomButton && (zoomButton.hidden = !1);
        const o = t.dataset.imageSrc,
          i = t.dataset.imageSrcset,
          s = t.dataset.imageAlt || "",
          c = t.hasAttribute("data-fabric-thumb"),
          imageFit = t.dataset.imageFit || "",
          l = galleryRoot && galleryRoot.querySelector("[data-fabric-main-label]");
        if (c && !o) {
          t.hidden = !0;
          t.classList.remove("is-active");
          t.setAttribute("aria-selected", "false");
          const fallback = g().find((thumb) => !thumb.hasAttribute("data-fabric-thumb"));
          if (fallback && fallback !== t) k(fallback, n);
          return;
        }
        if (o) {
          const done = () => {
            (e.classList.remove("is-loading"),
              e.removeEventListener("load", done),
              e.removeEventListener("error", done));
          };
          (e.classList.add("is-loading"),
            e.classList.toggle("is-fabric-closeup", c),
            e.classList.toggle("is-contained-static", !c && imageFit === "contain"),
            l &&
              ((l.hidden = !c),
              (l.textContent = c
                ? t.dataset.fabricLabel ||
                  String(s).replace(/\s*fabric close-up\s*$/i, "")
                : "")),
            i ? (e.srcset = i) : e.removeAttribute("srcset"),
            e.addEventListener("load", done),
            e.addEventListener("error", done),
            (e.src = o),
            (e.alt = s),
            e.complete && done());
        }
        (!n && m && C(f), b());
      }
      function C(t) {
        if (!o) return;
        const e = o.querySelector("[data-modal-image]"),
          r = o.querySelector("[data-modal-current]"),
          a = o.querySelector("[data-modal-total]"),
          i = h();
        if (!e || !i[t]) return;
        const s = i[t];
        e.style.opacity = "0.5";
        const c = new Image();
        ((c.onload = () => {
          ((e.src = s.src), (e.alt = s.alt), (e.style.opacity = "1"));
        }),
          (c.onerror = () => {
            ((e.src = s.src), (e.style.opacity = "1"));
          }),
          (c.src = s.src),
          r && (r.textContent = t + 1),
          a && (a.textContent = i.length),
          n.forEach((t) => {
            const e = String(t.dataset.mediaId || "") === s.mediaId;
            (t.classList.toggle("is-active", e),
              e &&
                t.scrollIntoView({
                  behavior: "smooth",
                  inline: "center",
                  block: "nearest",
                }));
          }));
      }
      function $() {
        if (!o) return;
        ((m = !0),
          o.classList.add("is-open"),
          o.setAttribute("aria-hidden", "false"),
          (document.body.style.overflow = "hidden"),
          C(f));
        const t = o.querySelector("[data-modal-close]");
        t && t.focus();
      }
      function N() {
        o &&
          ((m = !1),
          o.classList.remove("is-open"),
          o.setAttribute("aria-hidden", "true"),
          (document.body.style.overflow = ""),
          a && a.focus());
      }
      function I(t) {
        const e = h();
        if (0 === e.length) return;
        const r = (f + t + e.length) % e.length;
        ((f = r), C(r));
        const n = g()[r];
        n && k(n, !0);
      }
      if (
        (i &&
          (i.addEventListener(
            "touchstart",
            (t) => {
              ((A = t.changedTouches[0].screenX), (E = !0));
            },
            { passive: !0 },
          ),
          i.addEventListener(
            "touchend",
            (t) => {
              E && ((q = t.changedTouches[0].screenX), L(), (E = !1));
            },
            { passive: !0 },
          ),
          i.addEventListener("mousedown", (t) => {
            ((A = t.screenX), (E = !0), (i.style.cursor = "grabbing"));
          }),
          i.addEventListener("mouseup", (t) => {
            E && ((q = t.screenX), L(), (E = !1), (i.style.cursor = "grab"));
          }),
          i.addEventListener("mouseleave", () => {
            E && ((E = !1), (i.style.cursor = "grab"));
          }),
          (i.style.cursor = "grab")),
        c && c.addEventListener("click", () => S("prev")),
        l && l.addEventListener("click", () => S("next")),
        d && d.addEventListener("click", () => x(-1)),
        u && u.addEventListener("click", () => x(1)),
        r.forEach((t) => {
          t.addEventListener("click", () => {
            k(t);
          });
        }),
        a &&
          a.addEventListener("click", () => {
            window.matchMedia("(max-width: 749px)").matches || $();
          }),
        e)
      ) {
        ((e.style.cursor = window.matchMedia("(max-width: 749px)").matches
          ? "grab"
          : "zoom-in"),
          e.addEventListener("click", () => {
            window.matchMedia("(max-width: 749px)").matches || $();
          }));
        let t = 0;
        (e.addEventListener(
          "touchstart",
          (e) => {
            t = e.changedTouches[0].screenX;
          },
          { passive: !0 },
        ),
          e.addEventListener(
            "touchend",
            (e) => {
              const r = e.changedTouches[0].screenX,
                n = t - r;
              Math.abs(n) > 50 && x(n > 0 ? 1 : -1);
            },
            { passive: !0 },
          ));
      }
      if (o) {
        o.querySelectorAll("[data-modal-close]").forEach((t) => {
          t.addEventListener("click", N);
        });
        const t = o.querySelector("[data-modal-prev]"),
          e = o.querySelector("[data-modal-next]");
        (t && t.addEventListener("click", () => I(-1)),
          e && e.addEventListener("click", () => I(1)),
          o.querySelectorAll("[data-modal-thumb]").forEach((t) => {
            t.addEventListener("click", () => {
              const e = g(),
                r = e.findIndex(
                  (e) =>
                    String(e.dataset.mediaId || "") ===
                    String(t.dataset.mediaId || ""),
                );
              if (-1 === r) return;
              ((f = r), C(r));
              const n = e[r];
              n && k(n, !0);
            });
          }),
          o.addEventListener("keydown", (t) => {
            if (m)
              switch (t.key) {
                case "Escape":
                  N();
                  break;
                case "ArrowLeft":
                  I(-1);
                  break;
                case "ArrowRight":
                  I(1);
                  break;
                case "Tab":
                  const e = o.querySelectorAll(
                    'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
                  );
                  if (0 === e.length) return;
                  const r = e[0],
                    n = e[e.length - 1];
                  t.shiftKey && document.activeElement === r
                    ? (t.preventDefault(), n.focus())
                    : t.shiftKey ||
                      document.activeElement !== n ||
                      (t.preventDefault(), r.focus());
              }
          }));
        let r = 0;
        (o.addEventListener(
          "touchstart",
          (t) => {
            r = t.changedTouches[0].screenX;
          },
          { passive: !0 },
        ),
          o.addEventListener(
            "touchend",
            (t) => {
              const e = t.changedTouches[0].screenX,
                n = r - e;
              Math.abs(n) > 50 && I(n > 0 ? 1 : -1);
            },
            { passive: !0 },
          ));
      }
      const M = t.querySelector(".gallery-thumbs");
      let T;
      function D(t) {
        return String(t || "")
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-+|-+$/g, "");
      }
      function P(t, e) {
        return !!e && -1 !== D(String(t || "")).indexOf(e);
      }
      (M &&
        M.addEventListener("keydown", (t) => {
          const e = g();
          if (0 !== e.length)
            if ("ArrowLeft" === t.key) {
              const t = (f - 1 + e.length) % e.length;
              (k(e[t]), e[t].focus());
            } else if ("ArrowRight" === t.key) {
              const t = (f + 1) % e.length;
              (k(e[t]), e[t].focus());
            }
        }),
        y(),
        b(),
        window.addEventListener("resize", () => {
          (clearTimeout(T),
            (T = setTimeout(() => {
              (y(), b(), w(f));
            }, 150)));
        }));
      let z = null;
      function B() {
        const e = D(
            (function () {
              const e = t.querySelectorAll("[data-product-color-current]");
              for (const t of e) {
                const e = (t.textContent || "").trim();
                if (e) return e;
              }
              const r =
                (
                  t.querySelector(".color-opts-grid.is-active") ||
                  t.querySelector(".color-opts-grid") ||
                  t
                ).querySelector(
                  '.color-opt.is-selected, .color-opt[aria-pressed="true"]',
                ) ||
                t.querySelector(
                  '.color-opt.is-selected, .color-opt[aria-pressed="true"]',
                );
              return r ? (r.dataset.optionValue || "").trim() : "";
            })(),
          ),
          a = "" !== e;
        let o = 0,
          i = null;
        (r.forEach((t) => {
          if (t.hasAttribute("data-static-thumb")) return;
          let r = !0;
          (a &&
            (r = P(
              t.dataset.imageAlt ||
                (t.querySelector("img") ? t.querySelector("img").alt : "") ||
                "",
              e,
            )),
            (t.hidden = !r && !t.classList.contains("is-active")),
            r && ((o += 1), i || (i = t)));
        }),
          n.forEach((t) => {
            if (t.hasAttribute("data-static-thumb")) return;
            let r = !0;
            (a &&
              (r = P(
                t.dataset.alt ||
                  (t.querySelector("img") ? t.querySelector("img").alt : "") ||
                  "",
                e,
              )),
              (t.hidden = !r));
          }),
          a &&
            0 === o &&
            (r.forEach((t) => {
              t.hasAttribute("data-static-thumb") ||
                ((t.hidden = !1), i || (i = t));
            }),
            n.forEach((t) => {
              t.hidden = !1;
            })),
          (p = 0),
          s && (s.style.transform = "translateX(0)"),
          hydrateVisibleThumbs(),
          y(),
          b());
        const c = g();
        !c.some((t) => t.classList.contains("is-active")) && i
          ? k(i, !1)
          : c.length > 0 && w(f);
      }
      function O() {
        (clearTimeout(z), (z = setTimeout(B, 0)));
      }
      return (
        O(),
        t.querySelectorAll(".color-opt").forEach((t) => {
          t.addEventListener("click", O);
        }),
        {
          setMediaId(t) {
            if (!t) return;
            const e = r.find((e) => e.dataset.mediaId === String(t));
            e && k(e);
          },
          setVisibleMediaIds(t, e, a = "") {
            const o = Array.isArray(t)
                ? t.map((t) => String(t)).filter(Boolean)
                : [],
              i = new Set(o),
              c = i.size > 0;
            function l(t) {
              if (!a || !t) return !1;
              const e = (t) =>
                  t
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, "-")
                    .replace(/^-|-$/g, ""),
                r = e(t),
                n = e(a);
              return !(!r || !n || (r !== n && !r.startsWith(n + "-")));
            }
            (r.forEach((t) => {
              if (t.hasAttribute("data-static-thumb")) return;
              let e;
              ((e = c
                ? i.has(String(t.dataset.mediaId || ""))
                : !a ||
                  l(t.dataset.imageAlt || t.querySelector("img")?.alt || "")),
                (t.hidden = !e));
            }),
              n.forEach((t) => {
                if (t.hasAttribute("data-static-thumb")) return;
                let e;
                ((e = c
                  ? i.has(String(t.dataset.mediaId || ""))
                  : !a ||
                    l(t.dataset.alt || t.querySelector("img")?.alt || "")),
                  (t.hidden = !e));
              }),
              (p = 0),
              s && (s.style.transform = "translateX(0)"));
            const d = g(),
              u = d.filter((t) => !t.hasAttribute("data-static-thumb")),
              f =
                (e
                  ? d.find((t) => String(t.dataset.mediaId || "") === String(e))
                  : null) ||
                u[0] ||
                r[0];
            (hydrateVisibleThumbs(), y(), f && k(f, !1));
          },
          openZoom() {
            $();
          },
        }
      );
    })(o);
    ((function (t) {
      const e = Array.from(t.querySelectorAll("[data-variant-tab]")),
        r = Array.from(t.querySelectorAll(".variant-panel")),
        n = t.querySelector(".variant-filter-bar");
      if (0 === e.length || 0 === r.length) return;
      function a(t = !1) {
        const r = e.filter(
            (t) => "none" !== window.getComputedStyle(t).display,
          ),
          n =
            r.find((t) => t.classList.contains("is-active")) ||
            r.find((t) => "true" === t.getAttribute("aria-selected")) ||
            r[0] ||
            e[0];
        return (
          (t &&
            window.matchMedia("(max-width: 749px)").matches &&
            r.find((t) =>
              (t.querySelector(".variant-tab-label")?.textContent || "")
                .trim()
                .toLowerCase()
                .includes("size"),
            )) ||
          n
        );
      }
      function o(t, n = !1, a = !1) {
        const o = t.dataset.tabTarget;
        (e.forEach((e) => {
          const r = e === t;
          (e.classList.toggle("is-active", r),
            e.setAttribute("aria-selected", String(r)),
            e.setAttribute("tabindex", r ? "0" : "-1"));
        }),
          r.forEach((t) => {
            const e = t.id === o;
            (t.classList.toggle("is-active", e),
              e ? t.removeAttribute("hidden") : t.setAttribute("hidden", ""));
          }),
          n && t.focus({ preventScroll: !0 }),
          a &&
            window.matchMedia("(max-width: 749px)").matches &&
            t.scrollIntoView({
              behavior: "smooth",
              inline: "center",
              block: "nearest",
            }));
      }
      e.forEach((t, r) => {
        (t.addEventListener("click", () => {
          o(t, !1, !0);
        }),
          t.addEventListener("keydown", (n) => {
            let a = r;
            if ("ArrowRight" === n.key) a = (r + 1) % e.length;
            else if ("ArrowLeft" === n.key) a = (r - 1 + e.length) % e.length;
            else if ("Home" === n.key) a = 0;
            else {
              if ("End" !== n.key)
                return "Enter" === n.key || " " === n.key
                  ? void o(t, !1)
                  : void 0;
              a = e.length - 1;
            }
            (n.preventDefault(), o(e[a], !0, !0));
          }));
      });
      let i,
        s = window.matchMedia("(max-width: 749px)").matches;
      function c(t = !1) {
        const r = window.matchMedia("(max-width: 749px)").matches;
        if (
          ((function () {
            if (!n) return;
            const t = e.filter(
                (t) => "none" !== window.getComputedStyle(t).display,
              ),
              r = t.length > 3 ? 3.3 : Math.max(t.length, 1);
            n.style.setProperty("--visible-tab-count", String(r));
          })(),
          t && r)
        ) {
          const t = a(!0);
          return (
            t && !t.classList.contains("is-active") && o(t, !1),
            void (s = r)
          );
        }
        if (s === r) return;
        const i =
          e.find((t) => t.classList.contains("is-active")) ||
          e.find((t) => "true" === t.getAttribute("aria-selected")) ||
          a(r);
        (i && o(i, !1), (s = r));
      }
      if (
        (c(!0),
        window.addEventListener("resize", () => {
          (clearTimeout(i), (i = setTimeout(c, 150)));
        }),
        n)
      ) {
        const f = n.closest("[data-variant-tabs]"),
          m = f ? f.querySelector("[data-variant-scroll-cue]") : null;
        function l() {
          if (!m) return;
          if (!(n.scrollWidth - n.clientWidth > 4)) return void (m.hidden = !0);
          m.hidden = !1;
          const t = n.scrollLeft + n.clientWidth >= n.scrollWidth - 12;
          m.classList.toggle("is-faded", t);
        }
        (n.addEventListener("scroll", l, { passive: !0 }),
          window.addEventListener("resize", l),
          requestAnimationFrame(l),
          m &&
            m.addEventListener("click", () => {
              n.scrollBy({
                left: Math.max(120, 0.6 * n.clientWidth),
                behavior: "smooth",
              });
            }));
        const p = 6;
        let g = null;
        function d(t) {
          if (!g) return;
          const e = t.clientX - g.startX;
          if (!g.dragging) {
            if (Math.abs(e) < p) return;
            ((g.dragging = !0), n.classList.add("is-dragging"));
          }
          ((n.scrollLeft = g.startScroll - e), t.preventDefault());
        }
        function u() {
          if (g) {
            if (g.dragging) {
              n.classList.remove("is-dragging");
              const t = (e) => {
                (e.stopPropagation(),
                  e.preventDefault(),
                  n.removeEventListener("click", t, !0));
              };
              (n.addEventListener("click", t, !0),
                setTimeout(() => n.removeEventListener("click", t, !0), 300));
            }
            (document.removeEventListener("pointermove", d),
              document.removeEventListener("pointerup", u),
              document.removeEventListener("pointercancel", u),
              (g = null));
          }
        }
        n.addEventListener("pointerdown", (t) => {
          "mouse" === t.pointerType &&
            0 === t.button &&
            ((g = {
              startX: t.clientX,
              startScroll: n.scrollLeft,
              dragging: !1,
            }),
            document.addEventListener("pointermove", d),
            document.addEventListener("pointerup", u),
            document.addEventListener("pointercancel", u));
        });
      }
    })(o),
      (function (t, e) {
        const r = t.querySelector("[data-sticky-atc]"),
          n = t.querySelector("[data-sticky-atc-submit]"),
          a = t.querySelector("[data-atc-anchor]");
        (n &&
          n.addEventListener("click", () => {
            "function" == typeof e.requestSubmit
              ? e.requestSubmit()
              : e.submit();
          }),
          r &&
            a &&
            void 0 !== window.IntersectionObserver &&
            new IntersectionObserver(
              (t) => {
                t.forEach((t) => {
                  r.classList.toggle("is-visible", !t.isIntersecting);
                });
              },
              { threshold: 0.2 },
            ).observe(a));
      })(o, l),
      (function (t) {
        t.querySelectorAll(
          "[data-wishlist-btn], [data-wishlist-btn-secondary]",
        ).forEach((t) => {
          const e = t.dataset.productId;
          e && i(t, e);
        });
      })(o));
    let $ = -1;
    const N = o.querySelector(".color-opts-grid[data-option-panel]");
    N && ($ = Number(N.dataset.optionPanel));
    const I = Array.from(o.querySelectorAll("[data-price]")),
      M = Array.from(o.querySelectorAll("[data-compare-wrap]")),
      T = Array.from(o.querySelectorAll("[data-compare-price]")),
      D = Array.from(o.querySelectorAll("[data-price-save]")),
      P = o.querySelector("[data-sticky-price]"),
      z = o.querySelector("[data-sticky-variant]"),
      B = o.querySelector("[data-sticky-atc-submit]"),
      O = o.querySelector("[data-add-to-cart]"),
      V = o.querySelector("[data-atc-main]"),
      H = o.dataset.addLabel || "Add to cart",
      _ = o.dataset.soldoutLabel || "Sold out",
      F = Number(o.dataset.productId || 0),
      R = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short" });
    let W = !1,
      j = null,
      U = null,
      X = 0,
      G = 0;
    function K(t, e, r) {
      const n = Math.ceil(e),
        a = Math.floor(r);
      if (!Number.isFinite(n) || !Number.isFinite(a) || a < n) return n;
      const o = a - n + 1;
      return (
        n +
        ((function (t) {
          const e = String(t || "");
          let r = 2166136261;
          for (let t = 0; t < e.length; t += 1)
            ((r ^= e.charCodeAt(t)), (r = Math.imul(r, 16777619)));
          return r >>> 0;
        })(t) %
          o)
      );
    }
    function J(t, e) {
      const r = new Date(t.getTime());
      let n = Math.max(0, Number(e) || 0);
      for (; n > 0;) {
        r.setDate(r.getDate() + 1);
        const t = r.getDay();
        0 !== t && 6 !== t && (n -= 1);
      }
      return r;
    }
    function Y(t, e = "") {
      try {
        const r = e
          ? new URL(e, window.location.origin)
          : new URL(window.location.href);
        t && r.searchParams.set("variant", String(t));
        const n = `${r.pathname}${r.search}${r.hash}`;
        window.history.replaceState({}, "", n);
      } catch (t) {}
    }
    async function Z(t, e = void 0) {
      if (!t) return !1;
      if (!A) return (window.location.assign(t), !1);
      (q && q.abort(),
        o.classList.add("is-variant-loading"),
        o.setAttribute("aria-busy", "true"));
      const i = new AbortController();
      q = i;
      try {
        const l = new URL(t, window.location.origin),
          d = new URL(l.toString());
        d.searchParams.set("sections", A);
        let u = "";
        const f = await fetch(d.toString(), {
          signal: i.signal,
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        if (f.ok)
          if (
            (f.headers.get("content-type") || "").includes("application/json")
          ) {
            const t = await f.json();
            t && "object" == typeof t && (u = t[A] || "");
          } else if (((u = await f.text()), u.trim().startsWith("{")))
            try {
              const t = JSON.parse(u);
              t && "object" == typeof t && (u = t[A] || "");
            } catch (t) {}
        if (!u) {
          const t = await fetch(l.toString(), {
            signal: i.signal,
            headers: { "X-Requested-With": "XMLHttpRequest" },
          });
          t.ok && (u = await t.text());
        }
        if (i.signal.aborted) return !1;
        const m = (function (t) {
          if (!t) return null;
          const e = document.createElement("template");
          return (
            (e.innerHTML = String(t).trim()),
            e.content.querySelector("[data-product-section]") ||
              (e.content.firstElementChild &&
              e.content.firstElementChild.matches("[data-product-section]")
                ? e.content.firstElementChild
                : null)
          );
        })(u);
        if (!m) return (window.location.assign(t), !1);
        Y(null, t);
          const p = {
            storageOption: null,
            buttonOption: null,
            activeVariantTab: "",
            colorOption: null,
            colorOptionIndex: -1,
            colorScrollLeft: 0,
          },
          g = o.querySelector(
            '[data-variant-tab].is-active, [data-variant-tab][aria-selected="true"]',
          );
        g &&
          (p.activeVariantTab =
            g.querySelector(".variant-tab-label")?.textContent || "");
        const h = o.querySelector(
          '[data-storage-option].is-selected, [data-storage-option][aria-pressed="true"]',
        );
        h &&
          (p.storageOption =
            h.dataset.storageLabel || h.dataset.optionValue || "");
        const b = o.querySelector(
          '[data-button-option-choice].is-selected, [data-button-option-choice][aria-pressed="true"]',
        );
        b && (p.buttonOption = b.dataset.buttonOptionLabel || "");

        const colorCandidate = o.querySelector(
          '.mobile-only-color-options [data-option-index][data-option-value].is-selected, .mobile-only-color-options [data-option-index][data-option-value][aria-pressed="true"], [data-product-color-options] [data-option-index][data-option-value].is-selected, [data-product-color-options] [data-option-index][data-option-value][aria-pressed="true"]',
        );
        if (colorCandidate) {
          p.colorOption = String(colorCandidate.dataset.optionValue || "").trim();
          p.colorOptionIndex = Number(colorCandidate.dataset.optionIndex);
        }
        const colorRail = o.querySelector(
          ".mobile-only-color-options .product-color-panels",
        );
        if (colorRail) p.colorScrollLeft = colorRail.scrollLeft || 0;

        const y = window.scrollY,
          v = o.getBoundingClientRect();
        if (
          (v.top,
          o.replaceWith(m),
          (function (t) {
            if (p.colorOption && Number.isFinite(p.colorOptionIndex)) {
              t.querySelectorAll(
                `[data-option-index="${p.colorOptionIndex}"][data-option-value]`,
              ).forEach((option) => {
                const isSelected = yt(
                  option.dataset.optionValue,
                  p.colorOption,
                );
                option.classList.toggle("is-selected", isSelected);
                option.setAttribute("aria-pressed", String(isSelected));
              });
              t.querySelectorAll("[data-product-color-current]").forEach(
                (currentLabel) => {
                  currentLabel.textContent = p.colorOption;
                  currentLabel.setAttribute("title", p.colorOption);
                },
              );
            }

            const restoredColorRail = t.querySelector(
              ".mobile-only-color-options .product-color-panels",
            );
            if (restoredColorRail && p.colorScrollLeft > 0) {
              restoredColorRail.scrollLeft = p.colorScrollLeft;
              requestAnimationFrame(() => {
                restoredColorRail.scrollLeft = p.colorScrollLeft;
              });
            }

            (s(t),
              r(t),
              (function (t = document) {
                const e = [
                    {
                      id: "small-single",
                      name: "Small Single",
                      imp: "2'6\" x 6'3\"",
                      w: 75,
                      l: 190,
                    },
                    {
                      id: "single",
                      name: "Single",
                      imp: "3'0\" x 6'3\"",
                      w: 90,
                      l: 190,
                    },
                    {
                      id: "small-double",
                      name: "Small Double",
                      imp: "4'0\" x 6'3\"",
                      w: 120,
                      l: 190,
                    },
                    {
                      id: "double",
                      name: "Double",
                      imp: "4'6\" x 6'3\"",
                      w: 135,
                      l: 190,
                      popular: !0,
                    },
                    {
                      id: "king",
                      name: "King",
                      imp: "5'0\" x 6'6\"",
                      w: 150,
                      l: 200,
                    },
                    {
                      id: "super-king",
                      name: "Super King",
                      imp: "6'0\" x 6'6\"",
                      w: 180,
                      l: 200,
                    },
                  ],
                  r = {
                    "divan-drawer": {
                      label: "Divan with Drawers",
                      fpAdd: { w: 6, l: 3 },
                      baseH: 39,
                      getDrawers: (t) => (t <= 90 ? "1 or 2" : "2 or 4"),
                    },
                    ottoman: {
                      label: "Ottoman",
                      fpAdd: { w: 6, l: 8 },
                      baseH: 40,
                      getLift: () => "End-opening gas lift",
                    },
                    "bed-frame": {
                      label: "Bed Frame",
                      fpAdd: { w: 8, l: 15 },
                      baseH: 35,
                      getClearance: () => "20-28",
                    },
                  },
                  n = [
                    { id: "20", label: '20" (50 cm)', height: 50 },
                    { id: "26", label: '26" (66 cm)', height: 66 },
                    { id: "32", label: '32" (81 cm)', height: 81 },
                    {
                      id: "floor",
                      label: "Floor Standing (135 cm)",
                      height: 135,
                    },
                  ];
                let a = "divan-drawer",
                  o = "double",
                  i = "20",
                  s = !1;
                const c = Array.from(t.querySelectorAll(".dims-type-tab")),
                  l = Array.from(t.querySelectorAll(".dims-size-pill")),
                  d = Array.from(t.querySelectorAll(".dims-hb-pill")),
                  u = t.querySelector(".dims-size-subtitle"),
                  f = t.querySelector("[data-units-toggle]");
                function m(t) {
                  const e = t / 2.54,
                    r = Math.floor(e / 12),
                    n = Math.round(e % 12);
                  return { feet: r, inches: n, display: `${r}'${n}"` };
                }
                function p(t) {
                  return s ? m(t).display : `${t} cm`;
                }
                function g() {
                  const c = e.find((t) => t.id === o) || e[3],
                    l = r[a] || r["divan-drawer"],
                    d = n.find((t) => t.id === i) || n[0];
                  if (!c) return;
                  const f = c.w + l.fpAdd.w,
                    g = c.l + l.fpAdd.l;
                  u &&
                    (u.textContent = s
                      ? `${c.imp} - Mattress: ${m(c.w).display} x ${m(c.l).display}`
                      : `${c.imp} - Mattress: ${c.w} x ${c.l} cm`);
                  const h = t.querySelector(".dims-dim-text:first-of-type"),
                    b = t.querySelector(".dims-dim-text:last-of-type");
                  (h && (h.textContent = p(f)), b && (b.textContent = p(g)));
                  const y = t.querySelectorAll(".dims-spec-group");
                  if (y.length >= 2) {
                    const t = y[0].querySelector(".dims-spec-value");
                    t &&
                      (t.innerHTML = s
                        ? `${m(c.w).display} x ${m(c.l).display} <span class="alt">(${c.imp})</span>`
                        : `${c.w} cm x ${c.l} cm <span class="alt">(${c.imp})</span>`);
                    const e = y[1].querySelector(".dims-spec-value");
                    e &&
                      (e.innerHTML = s
                        ? `${m(f).display} x ${m(g).display}`
                        : `${f} cm x ${g} cm`);
                  }
                  const v = t.querySelector(".dims-spec-dual");
                  if (v) {
                    const t = v.querySelectorAll(".dims-spec-group");
                    if (t.length >= 2) {
                      const e = t[0].querySelector(".dims-spec-value");
                      e && (e.textContent = p(l.baseH));
                      const r = t[1].querySelector(".dims-spec-value");
                      r &&
                        (l.getDrawers
                          ? (r.textContent = l.getDrawers(c.w))
                          : l.getLift
                            ? (r.textContent = l.getLift())
                            : l.getClearance &&
                              (r.textContent = l.getClearance()));
                    }
                  }
                  const S = t.querySelectorAll(".dims-explain-item");
                  if (S.length >= 4) {
                    const t = S[0].querySelector(".et-val");
                    t && (t.textContent = p(f));
                    const e = S[1].querySelector(".et-val");
                    e && (e.textContent = p(g));
                    const r = S[2].querySelector(".et-val");
                    r && (r.textContent = p(l.baseH));
                    const n = S[3].querySelector(".et-val");
                    n && (n.textContent = p(d.height));
                  }
                  t.querySelectorAll(".dims-compare-card").forEach((t, r) => {
                    t.classList.toggle("active", e[r]?.id === o);
                  });
                }
                function h(t) {
                  (c.forEach((t) => {
                    (t.classList.remove("active"),
                      t.setAttribute("aria-selected", "false"),
                      t.setAttribute("aria-pressed", "false"));
                  }),
                    t.classList.add("active"),
                    t.setAttribute("aria-selected", "true"),
                    t.setAttribute("aria-pressed", "true"));
                  const e = t.textContent.trim();
                  (Object.entries(r).forEach(([t, r]) => {
                    r.label === e && (a = t);
                  }),
                    g());
                }
                c.forEach((t) => {
                  t.addEventListener("click", () => h(t));
                });
                const b = t.querySelector(".dims-type-tabs");
                (b &&
                  b.addEventListener("keydown", (t) => {
                    const e = c.findIndex((t) => t === document.activeElement);
                    if (-1 === e) return;
                    let r = e;
                    ("ArrowRight" === t.key || "ArrowDown" === t.key
                      ? (t.preventDefault(), (r = (e + 1) % c.length))
                      : "ArrowLeft" === t.key || "ArrowUp" === t.key
                        ? (t.preventDefault(),
                          (r = (e - 1 + c.length) % c.length))
                        : "Home" === t.key
                          ? (t.preventDefault(), (r = 0))
                          : "End" === t.key &&
                            (t.preventDefault(), (r = c.length - 1)),
                      r !== e && (c[r].focus(), h(c[r])));
                  }),
                  l.forEach((t) => {
                    t.addEventListener("click", () => {
                      (l.forEach((t) => {
                        (t.classList.remove("active"),
                          t.setAttribute("aria-checked", "false"));
                      }),
                        t.classList.add("active"),
                        t.setAttribute("aria-checked", "true"));
                      const r = (t.childNodes[0]?.textContent || t.textContent)
                          .replace(/Popular/gi, "")
                          .trim(),
                        n = e.find((t) => t.name === r);
                      (n && (o = n.id), g());
                    });
                  }),
                  d.forEach((t) => {
                    t.addEventListener("click", () => {
                      (d.forEach((t) => {
                        (t.classList.remove("active"),
                          t.setAttribute("aria-checked", "false"));
                      }),
                        t.classList.add("active"),
                        t.setAttribute("aria-checked", "true"));
                      const e = t.textContent.trim(),
                        r = n.find((t) => t.label === e);
                      (r && (i = r.id), g());
                    });
                  }),
                  f &&
                    f.addEventListener("click", () => {
                      ((s = !s),
                        f.setAttribute("aria-checked", String(s)),
                        f.classList.toggle("is-imperial", s),
                        g());
                    }));
                const y = Array.from(t.querySelectorAll(".dims-compare-card"));
                (y.forEach((t) => {
                  t.addEventListener("click", () => {
                    const r = t.dataset.compareSize,
                      n = e.find((t) => t.id === r);
                    if (!n) return;
                    ((o = r),
                      y.forEach((e) => {
                        const r = e === t;
                        (e.classList.toggle("active", r),
                          e.setAttribute("aria-pressed", String(r)));
                      }),
                      l.forEach((t) => {
                        const e =
                          (t.childNodes[0]?.textContent || t.textContent)
                            .replace(/Popular/gi, "")
                            .trim() === n.name;
                        (t.classList.toggle("active", e),
                          t.setAttribute("aria-checked", String(e)));
                      }));
                    const a = l.find((t) => t.classList.contains("active"));
                    (a &&
                      a.scrollIntoView({
                        behavior: "smooth",
                        inline: "center",
                        block: "nearest",
                      }),
                      g());
                  });
                }),
                  g());
              })(t),
              (function (t = document) {
                const e = Array.from(t.querySelectorAll("[data-faq-item]"));
                0 !== e.length &&
                  e.forEach((t) => {
                    const r = t.querySelector("[data-faq-trigger]");
                    r &&
                      r.addEventListener("click", () => {
                        const r = t.classList.contains("is-open");
                        (e.forEach((t) => {
                          !(function (t) {
                            const e = t.querySelector("[data-faq-trigger]"),
                              r = e ? e.getAttribute("aria-controls") : "",
                              n = r ? document.getElementById(r) : null;
                            (t.classList.remove("is-open"),
                              e && e.setAttribute("aria-expanded", "false"),
                              n && n.setAttribute("hidden", ""));
                          })(t);
                        }),
                          r ||
                            (function (t) {
                              const e = t.querySelector("[data-faq-trigger]"),
                                r = e ? e.getAttribute("aria-controls") : "",
                                n = r ? document.getElementById(r) : null;
                              (t.classList.add("is-open"),
                                e && e.setAttribute("aria-expanded", "true"),
                                n && n.removeAttribute("hidden"));
                            })(t));
                      });
                  });
              })(t),
              n(t),
              (function (t = document) {
                (t.querySelectorAll("[data-scroll-chat]").forEach((t) => {
                  t.addEventListener("click", (t) => {
                    (t.preventDefault(),
                      document
                        .getElementById("sleep-expert-chat")
                        ?.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        }));
                  });
                }),
                  t.querySelectorAll("[data-focus-chat]").forEach((t) => {
                    t.addEventListener("click", (t) => {
                      (t.preventDefault(),
                        document
                          .getElementById("sleep-expert-chat")
                          ?.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                          }));
                      const e = document.getElementById("chat-input");
                      e &&
                        window.setTimeout(() => {
                          e.focus();
                        }, 250);
                    });
                  }),
                  t.querySelectorAll("[data-scroll-to-atc]").forEach((e) => {
                    e.addEventListener("click", (e) => {
                      (e.preventDefault(),
                        t
                          .querySelector("[data-add-to-cart]")
                          ?.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                          }));
                    });
                  }));
              })(t),
              a(t),
              c(t));
          })(m),
          (function (t, e, r = "") {
            if (!t) return;
            const n = (t) =>
                String(t || "")
                  .trim()
                  .toLowerCase(),
              a = Array.from(t.querySelectorAll("[data-variant-tab]")),
              o = n(r);
            if (o) {
              const t = a.find(
                (t) =>
                  n(t.querySelector(".variant-tab-label")?.textContent) === o,
              );
              if (t) return void t.click();
            }
            if (!Number.isFinite(e)) return;
            const i = t.querySelector(
                `[data-tab-current][data-option-index="${e}"]`,
              ),
              s = i ? i.closest("[data-variant-tab]") : null;
            s && s.click();
          })(m, e, p.activeVariantTab),
          p.storageOption)
        ) {
          const t = m.querySelector(
            `[data-storage-option][data-storage-label="${p.storageOption}"], [data-storage-option][data-option-value="${p.storageOption}"]`,
          );
          t && "none" !== t.style.display && t.click();
        }
        if (p.buttonOption) {
          const t = m.querySelector(
            `[data-button-option-choice][data-button-option-label="${p.buttonOption}"]`,
          );
          t && t.click();
        }
        return (
          m.getBoundingClientRect(),
          v.top < window.innerHeight && v.bottom > 0 && window.scrollTo(0, y),
          !0
        );
      } catch (e) {
        return (
          (e && "AbortError" === e.name) ||
            (console.warn(
              "Could not render product section for selected option:",
              e,
            ),
            window.location.assign(t)),
          !1
        );
      } finally {
        i.signal.aborted ||
          (o.classList.remove("is-variant-loading"),
          o.removeAttribute("aria-busy"));
      }
    }
    function Q({ visibleOnly: t = !1 } = {}) {
      const e = [];
      return (
        o
          .querySelectorAll("[data-option-index][data-option-value]")
          .forEach((r) => {
            const n = Number(r.dataset.optionIndex),
              a = String(r.dataset.optionValue || "").trim(),
              isSelected =
                r.classList.contains("is-selected") ||
                "true" === r.getAttribute("aria-pressed");
            if (
              t &&
              !(function (t) {
                if (!(t instanceof HTMLElement)) return !1;
                if (t.hidden || "none" === t.style.display) return !1;
                const e = t.closest("[data-fabric-panel]");
                return !(e && !e.classList.contains("is-active"));
              })(r)
            ) {
              return;
            }
            if (!Number.isFinite(n) || !a || !isSelected) return;

            const isVisibleMobileColour = Boolean(
              r.closest(".mobile-only-color-options"),
            );
            if (isVisibleMobileColour || !e[n]) e[n] = a;
          }),
        e
      );
    }
    const tt = Number(b.value),
      et = m.find((t) => t.id === tt) || null,
      rt = v && !et,
      nt = (() => {
        try {
          return new URL(window.location.href).searchParams.has(
            "option_values",
          );
        } catch (t) {
          return !1;
        }
      })(),
      at = (t) =>
        String(t || "")
          .trim()
          .replace(/\s+/g, " ")
          .toLowerCase(),
      ot = (t, e) => at(t) === at(e),
      it = Q(),
      st = it.some((t) => "" !== String(t || "").trim()),
      ct = (et && Array.isArray(et.options) ? et.options.slice() : []).slice();
    st &&
      it.forEach((t, e) => {
        "" !== String(t || "").trim() && (ct[e] = t);
      });
    const lt = Boolean(
        st &&
        et &&
        Array.isArray(et.options) &&
        ct.some(
          (t, e) => "" !== String(t || "").trim() && !ot(t, et.options[e]),
        ),
      ),
      dt = st
        ? m.find(
            (t) =>
              Array.isArray(t.options) &&
              t.options.every((t, e) => ot(t, ct[e])),
          )
        : null;
    let ut = dt || et || m.find((t) => t.available) || m[0],
      ft = Array.isArray(ut.options) ? ut.options.slice() : [];
    st && (rt || nt || lt) && (ft = ct);
    const mt = Boolean(lt && !dt && p);
    let pt = Promise.resolve();
    function gt() {
      return v && !L;
    }
    async function ht(t) {
      return (
        !!t &&
        (!!L ||
          x ||
          ((x = (async () => {
            try {
              const e = await fetch(`/products/${t}.js`);
              if (!e.ok) return !1;
              const r = await e.json();
              if (Array.isArray(r.variants) && r.variants.length > 0) {
                !(function (t) {
                  if (!Array.isArray(t)) return t;
                  for (const e of t) {
                    if (!e || Array.isArray(e.options)) continue;
                    const t = [];
                    (null != e.option1 &&
                      "" !== e.option1 &&
                      t.push(String(e.option1)),
                      null != e.option2 &&
                        "" !== e.option2 &&
                        t.push(String(e.option2)),
                      null != e.option3 &&
                        "" !== e.option3 &&
                        t.push(String(e.option3)),
                      t.length > 0 && (e.options = t));
                  }
                })(r.variants);
                const t = r.variants.length > E,
                  e = r.variants.length >= m.length;
                t || (e && m.length < E)
                  ? ((m = r.variants), (L = !0))
                  : e && (m = r.variants);
                const n = Number(b.value || tt || 0),
                  a =
                    m.find((t) => t.id === n) ||
                    m.find((t) => t.available) ||
                    m[0];
                return (
                  a && (ut = a),
                  (Array.isArray(ft) && 0 !== ft.length) ||
                    !a ||
                    !Array.isArray(a.options) ||
                    (ft = a.options.slice()),
                  L
                );
              }
              return !1;
            } catch (t) {
              return (console.warn("Could not load full product data:", t), !1);
            } finally {
              x = null;
            }
          })()),
          x))
      );
    }
    function bt(t) {
      return String(t || "")
        .trim()
        .replace(/\s+/g, " ")
        .toLowerCase();
    }
    function yt(t, e) {
      return bt(t) === bt(e);
    }
    function vt(t) {
      return m.find((e) => {
        if (!Array.isArray(e.options)) return !1;
        const r = t.filter((t) => "" !== String(t || "").trim()).length;
        return e.options.length === r && e.options.every((e, r) => yt(e, t[r]));
      });
    }
    function St() {
      return vt(ft);
    }
    function wt(t, e) {
      let r = null,
        n = -1;
      for (const a of m) {
        if (!a.available || !Array.isArray(a.options)) continue;
        let o = 0,
          i = !0;
        for (let r = 0; r < a.options.length; r++) {
          const n = a.options[r];
          if (r === t) {
            if (!yt(n, e)) {
              i = !1;
              break;
            }
            o++;
          } else if (ft[r]) {
            if (!yt(ft[r], n)) {
              i = !1;
              break;
            }
            o++;
          }
        }
        i && o > n && ((n = o), (r = a));
      }
      return r;
    }
    function At({ visibleOnly: t = !1 } = {}) {
      const e = Q({ visibleOnly: t });
      if (
        ((r = e),
        Array.isArray(r) && r.some((t) => "" !== String(t || "").trim()))
      )
        for (let t = 0; t < e.length; t++)
          "" !== String(e[t] || "").trim() && (ft[t] = e[t]);
      var r;
      return Array.isArray(ft) ? ft.slice() : [];
    }
    function qt() {
      o.querySelectorAll("[data-option-index][data-option-value]").forEach(
        (t) => {
          const e = Number(t.dataset.optionIndex),
            r = t.dataset.optionValue,
            n = yt(ft[e], r);
          if (
            (t.classList.toggle("is-selected", n),
            t.setAttribute("aria-pressed", String(n)),
            gt())
          )
            return;
          const a = m.find((t) =>
            t.options.every((t, n) =>
              n === e ? yt(t, r) : !ft[n] || yt(ft[n], t),
            ),
          );
          t.dataset.optionPrice = a ? String(Number(a.price || 0)) : "";
          const o = m.some(
            (t) =>
              !!t.available &&
              t.options.every((t, n) =>
                n === e ? yt(t, r) : !ft[n] || yt(ft[n], t),
              ),
          );
          ((t.disabled = !o), t.classList.toggle("is-unavailable", !o));
        },
      );
    }
    function Et() {
      if (
        (o.querySelectorAll("[data-tab-current]").forEach((t) => {
          const e = Number(t.dataset.optionIndex),
            r = ft[e] || "Select option";
          ((t.textContent = r), t.setAttribute("title", r));
        }),
        o
          .querySelectorAll("[data-tab-current][data-option-index]")
          .forEach((t) => {
            const e = Number(t.dataset.optionIndex),
              r = t.closest("[data-variant-tab]"),
              n = r ? r.querySelector(".variant-tab-icon") : null,
              a = (r?.querySelector(".variant-tab-label")?.textContent || "")
                .trim()
                .toLowerCase();
            if (!(
              r &&
              n &&
              Number.isFinite(e) &&
              (a.includes("storage") ||
                a.includes("drawer") ||
                a.includes("ottoman") ||
                a.includes("headboard") ||
                a.includes("height") ||
                a.includes("hight"))
            ))
              return;
            const i = o.querySelector(
                `[data-option-index="${e}"][data-option-value].is-selected, [data-option-index="${e}"][data-option-value][aria-pressed="true"]`,
              ),
              s = i?.querySelector(
                ".storage-opt-icon, .headboard-opt-icon, .opt-card-icon",
              );
            s &&
              ((n.innerHTML = s.innerHTML),
              n.classList.toggle(
                "variant-tab-icon--selected-art",
                Boolean(n.querySelector("img")),
              ));
          }),
        $ >= 0)
      ) {
        const t = ft[$] || "Select option";
        o.querySelectorAll("[data-product-color-current]").forEach((e) => {
          ((e.textContent = t), e.setAttribute("title", t));
        });
      }
    }
    function Lt(t) {
      return String(t || "")
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    }
    function xt() {
      const t = o.querySelector("[data-fabric-tabs]");
      if (!t) return;
      if ($ < 0) return;
      const e = t.querySelectorAll("[data-fabric-tab]"),
        r = o.querySelectorAll("[data-fabric-panel]");
      let n = (function (t) {
          const e = String(t || "").trim();
          if (!e) return "";
          const r = e.split(/\s+/).filter(Boolean);
          if (0 === r.length) return "";
          const n = r[r.length - 1];
          return "velvet" === n.toLowerCase() && r.length > 1
            ? Lt(`${r[r.length - 2]} ${n}`)
            : Lt(n);
        })(ft[$] || ""),
        a = !1;
      (e.forEach((t) => {
        const e = t.dataset.fabricTab === n;
        (e && (a = !0),
          t.classList.toggle("is-active", e),
          t.setAttribute("aria-pressed", String(e)));
      }),
        !a &&
          e.length > 0 &&
          ((n = e[0].dataset.fabricTab || ""),
          e.forEach((t, e) => {
            const r = 0 === e;
            (t.classList.toggle("is-active", r),
              t.setAttribute("aria-pressed", String(r)));
          })),
        r.forEach((t) => {
          t.classList.toggle("is-active", t.dataset.fabricPanel === n);
        }));
    }
    function kt() {
      return j && "function" == typeof j.getSelectedPrice
        ? Number(j.getSelectedPrice() || 0)
        : 0;
    }
    function Ct() {
      return j && "function" == typeof j.getSelectedComparePrice
        ? Number(j.getSelectedComparePrice() || 0)
        : 0;
    }
    function $t() {
      return U && "function" == typeof U.getSelectedPrice
        ? Number(U.getSelectedPrice() || 0)
        : 0;
    }
    p &&
      (gt() || m.length >= E || lt) &&
      ht(p).then(() => {
        if (k > 0) return;
        (At(), qt(), Et(), xt());
        const t = St();
        t && (Dt(t), Y(t.id));
      });
    let Nt = 0;
    async function It() {
      const t = o.dataset.productUrl || "";
      if (!t || !A)
        return void Mt(
          Number(o.dataset.vfixBasePrice || 0) || X,
          Number(o.dataset.vfixBaseComparePrice || 0) || G,
        );
      const e = ++Nt,
        r = (function () {
          const t = [],
            e = {};
          return (
            o
              .querySelectorAll("[data-option-value-id][data-option-index]")
              .forEach((t) => {
                const r = t.dataset.optionIndex;
                (e[r] || (e[r] = []), e[r].push(t));
              }),
            Object.keys(e).forEach((r) => {
              const n = e[r];
              if ("0" === r) {
                const e = o.querySelector("[data-fabric-panel].is-active");
                if (e) {
                  const n = e.querySelector(
                    '[data-option-index="0"].is-selected[data-option-value-id], [data-option-index="0"][aria-pressed="true"][data-option-value-id]',
                  );
                  if (n) return void (t[Number(r)] = n.dataset.optionValueId);
                }
              }
              for (let e = 0; e < n.length; e++) {
                const a = n[e];
                if (
                  a.classList.contains("is-selected") ||
                  "true" === a.getAttribute("aria-pressed")
                ) {
                  if ("0" === r) {
                    const t = a.closest("[data-fabric-panel]");
                    if (t && !t.classList.contains("is-active")) continue;
                  }
                  return void (t[Number(r)] = a.dataset.optionValueId);
                }
              }
            }),
            t
          );
        })()
          .filter(Boolean)
          .join(",");
      if (!r) return;
      const n = t + "?sections=" + A + "&option_values=" + r;
      try {
        const t = await fetch(n, {
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        if (e !== Nt) return;
        if (!t.ok) throw new Error("fetch failed");
        const r = await t.json(),
          a = (r && "object" == typeof r && r[A]) || "";
        if (!a) throw new Error("empty");
        const o = new DOMParser().parseFromString(a, "text/html"),
          i = o.querySelector("[data-price]"),
          s = o.querySelector("[data-compare-price]"),
          c = o.querySelector("[data-compare-wrap]");
        let l = 0;
        if (i) {
          const t = parseFloat(i.textContent.replace(/[^0-9.]/g, ""));
          isNaN(t) || (l = Math.round(100 * t));
        }
        let d = 0;
        if (s) {
          const t = parseFloat(s.textContent.replace(/[^0-9.]/g, ""));
          isNaN(t) || (d = Math.round(100 * t));
        }
        (c && c.hidden && (d = 0), (X = l), (G = d), Mt(l, d));
      } catch (t) {
        if (e !== Nt) return;
        Mt(
          X || Number(o.dataset.vfixBasePrice || 0),
          G || Number(o.dataset.vfixBaseComparePrice || 0),
        );
      }
    }
    function Mt(t, r) {
      const n = kt(),
        a = Ct(),
        o = t + n + $t(),
        i = r + a,
        s = i > o;
      (I.forEach((t) => {
        t.textContent = e(y, o);
      }),
        P && (P.textContent = e(y, o)),
        M.forEach((t) => {
          t.hidden = !s;
        }),
        T.forEach((t) => {
          t.textContent = s ? e(y, i) : "";
        }),
        D.forEach((t) => {
          if (s && i > 0) {
            const e = Math.round(((i - o) / i) * 100);
            t.textContent = `Save ${e}%`;
          } else t.textContent = "";
        }));
    }
    function Tt() {
      const t = document.querySelector("[data-whats-in-box]");
      if (!t || !l) return;
      const e = t.querySelector("[data-wib-included-list]");
      if (!e) return;
      const r = document.querySelector("[data-specs-table]");
      function n(t) {
        if (!r || !t) return "";
        const e = String(t).trim().toLowerCase(),
          n = r.querySelectorAll("[data-spec-row]");
        for (const t of n)
          if (
            String(t.querySelector("[data-spec-label]")?.textContent || "")
              .trim()
              .toLowerCase() === e
          )
            return String(
              t.querySelector("[data-spec-value]")?.textContent || "",
            ).trim();
        return "";
      }
      function a(t, r) {
        if (!t || !r) return;
        const n = e.querySelector(`[data-wib-static-slot="${t}"]`),
          a = n?.parentElement?.querySelector("[data-wib-item-copy]");
        a && a.replaceChildren(s(r));
      }
      function i(t) {
        const e = String(t || "").trim();
        if (!e) return "";
        const r = e.toLowerCase();
        return "headboard hight" === r
          ? "Headboard Height"
          : "storage add-on" === r || "storage add on" === r
            ? "Storage Add-on"
            : "button option" === r
              ? "Button Option"
              : e.replace(/\bhight\b/gi, "Height");
      }
      function s(t) {
        const e = document.createElement("span");
        e.className = "whats-in-box-copy";
        const r = String(t).indexOf(":");
        if (-1 === r) return ((e.textContent = String(t).trim()), e);
        const n = String(t).slice(0, r).trim(),
          a = String(t)
            .slice(r + 1)
            .trim(),
          o = document.createElement("span"),
          s = document.createElement("span");
        return (
          (o.className = "whats-in-box-item-heading"),
          (o.textContent = `${i(n)}:`),
          (s.className = "whats-in-box-item-value"),
          (s.textContent = a),
          e.append(o, s),
          e
        );
      }
      const c = String(o.dataset.productTypeName || "").trim(),
        d = String(o.dataset.productCategoryName || "").trim(),
        u = String(o.dataset.productCollectionTitle || "").trim(),
        f = String(o.dataset.productDisplayType || "").trim(),
        m = c || d || u || f,
        p = n("Headboard"),
        g = n("Legs");
      (m && a("collection", `Type: ${m}`),
        p && a("headboard", `Headboard: ${p}`),
        g && a("legs", `Legs: ${g}`),
        e
          .querySelectorAll("[data-wib-dynamic-item]")
          .forEach((t) => t.remove()));
      const h = [],
        b = String(o.dataset.productTitle || "").trim();
      let y = "",
        v = "";
      const S = [];
      if (
        (o.querySelectorAll("[data-variant-tab]").forEach((t) => {
          const e = String(
              t.querySelector(".variant-tab-label")?.textContent || "",
            ).trim(),
            r = t.querySelector("[data-tab-current]"),
            n = String(r?.textContent || "").trim(),
            a = e.toLowerCase();
          e &&
            n &&
            ((function (t) {
              return t.includes("size");
            })(a)
              ? (y = n)
              : (function (t) {
                    return t.includes("colour") || t.includes("color");
                  })(a)
                ? (v = n)
                : S.push(`${i(e)}: ${n}`));
        }),
        b)
      ) {
        const t = ["Detail: " + b];
        (y && t.push(y), v && t.push(v), h.push(t.join(", ")));
      }
      h.push(...S);
      const w = String(
        l.querySelector('input[name="properties[Storage Add-on]"]')?.value ||
          "",
      ).trim();
      w && h.push(`Storage Add-on: ${w}`);
      const A = String(
        l.querySelector('input[name="properties[Button Option]"]')?.value || "",
      ).trim();
      A && h.push(`Button Option: ${A}`);
      const q = String(
        l.querySelector('input[name="properties[Mattress Add-on]"]')?.value ||
          "",
      ).trim();
      (q && h.push(`Mattress: ${q}`),
        String(
          l.querySelector('input[name="properties[Service Add-ons]"]')?.value ||
            "",
        )
          .split(",")
          .map((t) => t.trim())
          .filter(Boolean)
          .forEach((t) => {
            h.push(`Optional service: ${t}`);
          }),
        h.reverse().forEach((t) => {
          const r = document.createElement("li"),
            n = document.createElement("span"),
            a = document.createElement("span");
          ((r.className = "whats-in-box-item whats-in-box-item--dynamic"),
            r.setAttribute("data-wib-dynamic-item", ""),
            (n.className = "mi"),
            n.setAttribute("aria-hidden", "true"),
            (n.textContent = "check_circle"),
            a.setAttribute("data-wib-item-copy", ""),
            a.append(s(t)),
            r.append(n, a),
            e.prepend(r));
        }));
    }
    function Dt(t, r = void 0) {
      const n = b.value;
      b.value = String(t.id);
      const a = n !== b.value;
      (a &&
        (b.dispatchEvent(new Event("input", { bubbles: !0 })),
        b.dispatchEvent(new Event("change", { bubbles: !0 }))),
        (X = Number(t.price || 0)),
        (G = Number(t.compare_at_price || 0)));
      const i = kt(),
        s = Ct(),
        c = $t(),
        l = Number(t.price || 0) + i + c,
        d = Number(t.compare_at_price || 0) + s,
        u = d > l;
      if (
        (I.forEach((t) => {
          t.textContent = e(y, l);
        }),
        P && (P.textContent = e(y, l)),
        M.forEach((t) => {
          t.hidden = !u;
        }),
        T.forEach((t) => {
          t.textContent = u ? e(y, d) : "";
        }),
        D.forEach((t) => {
          if (u && d > 0) {
            const e = Math.round(((d - l) / d) * 100);
            t.textContent = `Save ${e}%`;
          } else t.textContent = "";
        }),
        z && (z.textContent = t.options.filter(Boolean).join(" / ")),
        O && (O.disabled = !t.available),
        B && (B.disabled = !t.available),
        V && (V.textContent = t.available ? H : _),
        void 0 === r || r === $)
      ) {
        const e =
          $ >= 0 && Array.isArray(t.options)
            ? String(t.options[$] || "").trim()
            : "";
        C.setVisibleMediaIds(
          (function (t) {
            if (!t || !Array.isArray(t.options) || !Number.isFinite(h) || h < 0)
              return [];
            const e = String(t.options[h] || "").trim();
            return e && g && "object" == typeof g && Array.isArray(g[e])
              ? g[e]
              : [];
          })(t),
          t.featured_media && t.featured_media.id,
          e,
        );
      }
      ((function (t) {
        o.querySelectorAll("[data-option-price-delta]").forEach((r) => {
          const n = r.closest("[data-option-value]");
          if (!n) return;
          if (
            n.classList.contains("is-selected") ||
            "true" === n.getAttribute("aria-pressed")
          )
            return (
              (r.textContent = "Selected"),
              void r.classList.remove("is-plus", "is-minus", "is-zero")
            );
          if ((n.dataset.optionValue || "").toUpperCase().includes("FREE"))
            return (
              (r.textContent = ""),
              void r.classList.remove("is-plus", "is-minus", "is-zero")
            );
          const a = Number(n.dataset.optionPrice);
          if (!Number.isFinite(a))
            return (
              (r.textContent = ""),
              void r.classList.remove("is-plus", "is-minus", "is-zero")
            );
          const o = a - Number(t || 0);
          o <= 0
            ? ((r.textContent = ""),
              r.classList.remove("is-plus", "is-minus", "is-zero"))
            : ((r.textContent = (function (t, r) {
                const n = Number(r || 0),
                  a = e(t, Math.abs(n));
                return n > 0 ? `+${a}` : n < 0 ? `-${a}` : e(t, 0);
              })(y, o)),
              r.classList.toggle("is-plus", o > 0),
              r.classList.remove("is-minus"));
        });
      })(Number(t.price || 0)),
        (function (t) {
          const e = (function (t) {
            const e = Math.floor(Date.now() / 72e5),
              r = (function () {
                const t = o.querySelectorAll("[data-variant-tab]");
                for (const e of t) {
                  const t = e.querySelector(".variant-tab-label"),
                    r = e.querySelector(
                      "[data-tab-current][data-option-index]",
                    );
                  if (
                    !(t ? t.textContent : "")
                      .trim()
                      .toLowerCase()
                      .includes("size") ||
                    !r
                  )
                    continue;
                  const n = (r.textContent || "").trim();
                  if (n) return n;
                }
                return "the selected size";
              })(),
              n = t && t.id ? String(t.id) : r,
              a = `${F || o.dataset.productTitle || "product"}|${n}|${e}`,
              i = K(`${a}|hours`, 18, 36),
              s = K(`${a}|orders`, 6, 17),
              c = K(`${a}|stockRemaining`, 2, 7),
              l = c + K(`${a}|stockBuffer`, 5, 11),
              d = Math.max(1, l - c),
              u = Math.min(92, Math.max(20, Math.round((d / l) * 100))),
              f = J(new Date(), 3),
              m = J(new Date(), 5),
              p = K(`${a}|minutesAgo`, 4, 38);
            return {
              sizeLabel: r,
              orders: s,
              hoursWindow: i,
              stockRemaining: c,
              stockTotal: l,
              soldPercent: u,
              businessMinDays: 3,
              businessMaxDays: 5,
              startDateLabel: R.format(f),
              endDateLabel: R.format(m),
              minutesAgo: p,
            };
          })(t);
          (o.querySelectorAll("[data-cro-demand-title]").forEach((t) => {
            t.textContent = `${e.orders} UK orders recently`;
          }),
            o.querySelectorAll("[data-cro-demand-sub]").forEach((t) => {
              t.textContent = `Updated ${e.minutesAgo} minutes ago`;
            }),
            o.querySelectorAll("[data-cro-size-label]").forEach((t) => {
              t.textContent = e.sizeLabel;
            }),
            o.querySelectorAll("[data-cro-stock-left]").forEach((t) => {
              t.textContent = String(e.stockRemaining);
            }),
            o.querySelectorAll("[data-cro-stock-bar-count]").forEach((t) => {
              t.textContent = `Only ${e.stockRemaining} of ${e.stockTotal} remaining`;
            }),
            o.querySelectorAll("[data-cro-stock-fill]").forEach((t) => {
              t.style.width = `${e.soldPercent}%`;
            }),
            o.querySelectorAll("[data-cro-delivery-days]").forEach((t) => {
              t.textContent = `${e.businessMinDays}-${e.businessMaxDays} working days`;
            }),
            o.querySelectorAll("[data-cro-delivery-dates]").forEach((t) => {
              t.textContent = `${e.startDateLabel} - ${e.endDateLabel}`;
            }));
        })(t),
        a &&
          (function (t) {
            const e = { sectionId: A, variant: t };
            (o.dispatchEvent(
              new CustomEvent("variant:change", { bubbles: !0, detail: e }),
            ),
              document.dispatchEvent(
                new CustomEvent("variant:change", { detail: e }),
              ));
          })(t));
    }
    function Pt(t) {
      W = t;
      const e = m.find((t) => String(t.id) === String(b.value || "")) || ut,
        r = e ? Boolean(e.available) : v && "" !== String(b.value || "").trim();
      (O && (O.disabled = t || !r), B && (B.disabled = t || !r));
    }
    (o
      .querySelectorAll("[data-option-index][data-option-value]")
      .forEach((t) => {
        t.addEventListener("click", async () => {
          if (t.disabled) return;
          const e = Number(t.dataset.optionIndex),
            r = t.dataset.optionValue,
            n = t.dataset.optionUrl || "",
            a = t.dataset.optionValueId || "";
          if (!Number.isFinite(e) || !r) return;
          const i = v
            ? (function (t, e, r = "") {
                const n = String(e || "").trim();
                if (!n) return r || "";
                const a = (function (t = ft) {
                  const e = [];
                  return (
                    o
                      .querySelectorAll(
                        "[data-option-index][data-option-value-id]",
                      )
                      .forEach((t) => {
                        const r = Number(t.dataset.optionIndex),
                          n = String(t.dataset.optionValueId || "").trim(),
                          a =
                            t.classList.contains("is-selected") ||
                            "true" === t.getAttribute("aria-pressed");
                        if (!Number.isFinite(r) || !n || !a) return;
                        const panel = t.closest("[data-fabric-panel]");
                        if (panel && !panel.classList.contains("is-active"))
                          return;
                        const isVisibleMobileColour = Boolean(
                          t.closest(".mobile-only-color-options"),
                        );
                        if (isVisibleMobileColour || !e[r]) e[r] = n;
                      }),
                    Array.isArray(t) &&
                      t.forEach((t, r) => {
                        if (e[r]) return;
                        const n = (function (t, e) {
                          if (
                            !Number.isFinite(t) ||
                            "" === String(e || "").trim()
                          )
                            return "";
                          const r = Array.from(
                            o.querySelectorAll(
                              `[data-option-index="${t}"][data-option-value-id][data-option-value]`,
                            ),
                          ).find((t) => yt(t.dataset.optionValue, e));
                          return r
                            ? String(r.dataset.optionValueId || "").trim()
                            : "";
                        })(r, t);
                        n && (e[r] = n);
                      }),
                    e
                  );
                })();
                a[t] = n;
                const i = a.filter((t) => "" !== String(t || "").trim());
                if (0 === i.length) return r || "";
                let s;
                try {
                  s = r
                    ? new URL(r, window.location.origin)
                    : new URL(window.location.href);
                } catch (t) {
                  return r || "";
                }
                return (
                  s.searchParams.delete("variant"),
                  s.searchParams.set("option_values", i.join(",")),
                  `${s.pathname}${s.search}${s.hash}`
                );
              })(e, a, n)
            : n;
          var s;
          await ((s = (async function (t, e, r = "") {
            const n = ++k,
              a = ft.slice();
            if (
              ((ft[t] = e),
              (function (t = "") {
                if (!v || !t) return !1;
                try {
                  return new URL(t, window.location.origin).searchParams.has(
                    "option_values",
                  );
                } catch (t) {
                  return !1;
                }
              })(r))
            ) {
              (qt(), Et(), xt());
              let exactVariant = St();
              if (!exactVariant && !L && p) {
                await ht(p);
                if (n !== k) return;
                exactVariant = St();
                (qt(), Et(), xt());
              }
              if (exactVariant) {
                const r = String(b.value || "");
                return (
                  Dt(exactVariant, t),
                  void (r !== String(exactVariant.id) && Y(exactVariant.id))
                );
              }
              const closestVariant = wt(t, e);
              if (closestVariant) {
                ft = Array.isArray(closestVariant.options)
                  ? closestVariant.options.slice()
                  : a;
                (qt(), Et(), xt());
                const r = String(b.value || "");
                return (
                  Dt(closestVariant, t),
                  void (
                    r !== String(closestVariant.id) && Y(closestVariant.id)
                  )
                );
              }
              if (await Z(r, t)) return;
              const o = wt(t, e);
              if (o) {
                ft = Array.isArray(o.options) ? o.options.slice() : a;
                const e = String(b.value || "");
                (Dt(o, t), e !== String(o.id) && Y(o.id));
              }
              return;
            }
            if (p && !L) {
              const e = await ht(p);
              if (n !== k) return;
              if (!e && gt() && r) return void Z(r, t);
            }
            (qt(), Et(), xt());
            let o = St();
            if (!o) {
              if (v && r) return void Z(r, t);
              const n = wt(t, e);
              n &&
                ((ft = Array.isArray(n.options) ? n.options.slice() : a),
                (o = n));
            }
            if (!o) return ((ft = a), qt(), Et(), xt(), r ? void Z(r) : void 0);
            const i = String(b.value || "");
            (Dt(o, t), i !== String(o.id) && Y(o.id));
          })(e, r, i)),
          (pt = Promise.resolve(s).catch(
            (t) => (
              console.warn("Could not finish syncing the selected variant:", t),
              !1
            ),
          )),
          pt);
        });
      }),
      qt(),
      Et(),
      xt(),
      rt || mt || Dt(ut),
      (j = (function (t) {
        const e = t.querySelector("[data-storage-panel]"),
          r = t.querySelector("[data-product-form]");
        if (!e || !r) return null;
        const n = Array.from(e.querySelectorAll("[data-storage-option]")),
          a = t.querySelector("[data-storage-tab-current]"),
          o = e.getAttribute("aria-labelledby") || "",
          i = o ? t.querySelector(`#${o}`) : null,
          s = i ? i.querySelector(".variant-tab-icon") : null;
        if (0 === n.length) return null;
        const c = u("properties[Storage Add-on Variant ID]"),
          l = u("properties[Storage Add-on]");
        let d =
          n.find((t) => t.classList.contains("is-selected")) ||
          n.find((t) => !t.disabled) ||
          n[0];
        function u(t) {
          let e = r.querySelector(`input[name="${t}"]`);
          return (
            e ||
              ((e = document.createElement("input")),
              (e.type = "hidden"),
              (e.name = t),
              (e.value = ""),
              r.appendChild(e)),
            e
          );
        }
        function f(t) {
          if (!t)
            return (
              c && (c.value = ""),
              l && (l.value = ""),
              a && (a.textContent = ""),
              void (d = null)
            );
          (n.forEach((e) => {
            const r = e === t;
            (e.classList.toggle("is-selected", r),
              e.setAttribute("aria-pressed", String(r)));
          }),
            (d = t));
          const r = t.dataset.storageLabel || "",
            o = t.dataset.storageProductTitle || "";
          if (
            (c && (c.value = t.dataset.storageVariantId || ""),
            l && (l.value = [o, r].filter(Boolean).join(" - ")),
            a && ((a.textContent = r), a.setAttribute("title", r)),
            s)
          ) {
            const e = t.querySelector(".storage-opt-icon");
            e &&
              ((s.innerHTML = e.innerHTML),
              s.classList.toggle(
                "variant-tab-icon--selected-art",
                Boolean(s.querySelector("img")),
              ));
          }
          const i = e.closest("[data-product-section]");
          i &&
            i.dispatchEvent(new CustomEvent("storage:change", { bubbles: !0 }));
        }
        return (
          n.forEach((t) => {
            t.addEventListener("click", () => {
              t.disabled || f(t);
            });
          }),
          f(d),
          {
            hasSelection: () =>
              Boolean(d && !d.disabled && d.dataset.storageVariantId),
            getSelectedVariantId: () => (d && d.dataset.storageVariantId) || "",
            getSelectedPrice: () => (d && d.dataset.storagePrice) || "0",
            getSelectedComparePrice: () =>
              (d && d.dataset.storageComparePrice) || "0",
          }
        );
      })(o)),
      (U = (function (r) {
        const n = r.querySelector("[data-service-bundle]"),
          a = r.querySelector("[data-product-form]"),
          o = r.querySelector("[data-service-toggle]"),
          i = r.querySelector("[data-service-overlay]"),
          s = r.querySelector("[data-service-drawer]"),
          c = Array.from(r.querySelectorAll("[data-service-close]")),
          l = r.querySelector("[data-service-tab-eyebrow]"),
          d = r.querySelector("[data-service-tab-headline]"),
          u = r.querySelector("[data-service-tab-sub]"),
          f = r.querySelector("[data-service-tab-change]");
        if (!n || !a) return null;
        const m = Array.from(n.querySelectorAll("[data-service-option]"));
        if (0 === m.length) return null;
        const p = t(
            document.documentElement.lang || "en-GB",
            r.dataset.currency || "GBP",
          ),
          g = Boolean(o && i && s),
          h = {
            eyebrow: l ? l.textContent : "",
            headline: d ? d.textContent : "",
            subtitle: u ? u.textContent : "",
          },
          b = new Set(),
          y = S("properties[_Service Add-on Variant IDs]"),
          v = S("properties[Service Add-ons]");
        function S(t) {
          let e = a.querySelector(`input[name="${t}"]`);
          return (
            e ||
              ((e = document.createElement("input")),
              (e.type = "hidden"),
              (e.name = t),
              (e.value = ""),
              a.appendChild(e)),
            e
          );
        }
        function w() {
          return m.filter((t) => b.has(t));
        }
        function A() {
          return w().reduce(
            (t, e) => t + Number(e.dataset.servicePrice || 0),
            0,
          );
        }
        function q() {
          const t = w();
          (y &&
            (y.value = t
              .map((t) => t.dataset.serviceVariantId || "")
              .filter(Boolean)
              .join(",")),
            v &&
              (v.value = t
                .map((t) => {
                  const r = t.dataset.serviceGroupLabel || "",
                    n = t.dataset.serviceTitle || "",
                    a = Number(t.dataset.servicePrice || 0);
                  return [r, n, `(+${e(p, a)})`].filter(Boolean).join(" - ");
                })
                .filter(Boolean)
                .join(", ")));
        }
        function E() {
          if (!o) return;
          const t = w(),
            r = t.length > 0,
            n = A();
          (o.classList.toggle("is-added", r),
            o.setAttribute(
              "aria-label",
              r ? "Edit selected optional services" : "Open optional services",
            ),
            l && (l.textContent = r ? "Optional services added" : h.eyebrow),
            d &&
              (d.textContent = r
                ? 1 === t.length
                  ? t[0].dataset.serviceTitle || "1 service selected"
                  : `${t.length} services selected`
                : h.headline),
            u &&
              (u.textContent = r
                ? `Added ${e(p, n)}${t.length > 1 ? " total" : ""}`
                : h.subtitle),
            f && f.classList.toggle("is-visible", r));
        }
        function L(t) {
          const e = b.has(t),
            r = t.closest("[data-service-option-card]"),
            n = t.querySelector("[data-service-button-label]");
          (t.classList.toggle("is-selected", e),
            t.setAttribute("aria-pressed", String(e)),
            r && r.classList.toggle("is-selected", e),
            n && (n.textContent = e ? "Remove" : "Add"));
        }
        function x() {
          const t = n.closest("[data-product-section]");
          t &&
            t.dispatchEvent(new CustomEvent("service:change", { bubbles: !0 }));
        }
        function H(t) {
          if (!s) return;
          Array.from(
            s.querySelectorAll(
              'button, [href], input, select, textarea, [tabindex]',
            ),
          ).forEach((e) => {
            if (t)
              e.dataset.servicePrevTabindex
                ? (e.setAttribute("tabindex", e.dataset.servicePrevTabindex),
                  delete e.dataset.servicePrevTabindex)
                : e.removeAttribute("tabindex");
            else {
              e.hasAttribute("tabindex") &&
                (e.dataset.servicePrevTabindex =
                  e.getAttribute("tabindex") || "");
              e.setAttribute("tabindex", "-1");
            }
          });
        }
        function k() {
          g &&
            (i.classList.remove("open"),
            i.setAttribute("aria-hidden", "true"),
            s.classList.remove("open"),
            s.setAttribute("aria-hidden", "true"),
            (s.inert = !0),
            H(!1),
            (document.body.style.overflow = ""),
            o.focus());
        }
        return (
          m.forEach((t) => {
            (L(t),
              t.addEventListener("click", () => {
                (b.has(t) ? b.delete(t) : b.add(t), L(t), q(), E(), x());
              }));
          }),
          q(),
          E(),
          g &&
            (o.addEventListener("click", (t) => {
              const e = o.querySelector(".mattress-tab-arrow");
              if (
                e &&
                (t.target === e || e.contains(t.target)) &&
                o.classList.contains("is-added")
              )
                return (
                  t.stopPropagation(),
                  b.clear(),
                  m.forEach((t) => L(t)),
                  q(),
                  E(),
                  void x()
                );
              !(function () {
                if (!g) return;
                (i.classList.add("open"),
                  i.setAttribute("aria-hidden", "false"),
                  s.classList.add("open"),
                  s.setAttribute("aria-hidden", "false"),
                  (s.inert = !1),
                  H(!0),
                  (document.body.style.overflow = "hidden"));
                const t = s.querySelector("[data-service-close]");
                t && setTimeout(() => t.focus(), 100);
              })();
            }),
            i.addEventListener("click", k),
            c.forEach((t) => {
              t.addEventListener("click", k);
            }),
            s.addEventListener("keydown", (t) => {
              if ("Escape" === t.key) return (t.preventDefault(), void k());
              if ("Tab" !== t.key) return;
              const e = s
                ? Array.from(
                    s.querySelectorAll(
                      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
                    ),
                  ).filter((t) => !t.disabled && null !== t.offsetParent)
                : [];
              if (0 === e.length) return;
              const r = e[0],
                n = e[e.length - 1];
              t.shiftKey && document.activeElement === r
                ? (t.preventDefault(), n.focus())
                : t.shiftKey ||
                  document.activeElement !== n ||
                  (t.preventDefault(), r.focus());
            }),
            H(!1)),
          {
            hasSelection: () => b.size > 0,
            getSelectedItems: () =>
              w()
                .map((t) => {
                  const e = Number(t.dataset.serviceVariantId || 0);
                  return e
                    ? {
                        variantId: e,
                        title: t.dataset.serviceTitle || "",
                        price: Number(t.dataset.servicePrice || 0),
                      }
                    : null;
                })
                .filter(Boolean),
            getSelectedPrice: () => A(),
          }
        );
      })(o)),
      (function (t) {
        const e = t.querySelector("[data-wing-headboard-storage-bundle]"),
          r = t.querySelector("[data-wing-headboard-storage]");
        if (!e && !r) return null;
        const n = "true" === r?.dataset.isWingHeadboard,
          a =
            e?.hasAttribute("data-divan-collection") ||
            r?.hasAttribute("data-divan-collection"),
          o = ["no storage", "2 drawers left", "2 drawers right"],
          i = [
            "no storage",
            "2 drawers left",
            "2 drawers right",
            "2-drawer footend",
            "4 drawers",
          ],
          s = ["no storage", "2 drawers left", "2 drawers right"],
          c = [
            "no storage",
            "2 drawers left",
            "2 drawers right",
            "2-drawer footend",
            "4 drawers",
          ],
          l = [
            "no storage (slatted base)",
            "no storage (blackboard)",
            "metal gas lift storage + blackboard",
            "slatted base",
            "solid blackboard base",
            "no storage (reinforced base)",
            "gas lift storage base",
            "standard bed frame (no storage)",
            "reinforced solid heavy base (no storage)",
            "gas lift ottoman storage base",
          ];
        function d(t) {
          if (!t) return !1;
          const e = t.toLowerCase().trim();
          return e.includes("single") || e.includes("3ft");
        }
        function u(t) {
          return n && a ? (t ? o : i) : a ? (t ? s : c) : l;
        }
        function f(t) {
          const n = u(t);
          if (e) {
            const t = e.querySelectorAll("[data-storage-option]");
            t.forEach((e) => {
              const r = (e.dataset.storageLabel || "").toLowerCase().trim(),
                a = n.includes(r);
              if (
                ((e.style.display = a ? "" : "none"),
                !a && e.classList.contains("is-selected"))
              ) {
                (e.classList.remove("is-selected"),
                  e.setAttribute("aria-pressed", "false"));
                const r = Array.from(t).find((t) => {
                  const e = (t.dataset.storageLabel || "").toLowerCase().trim();
                  return n.includes(e) && !t.disabled;
                });
                r && r.click();
              }
            });
          }
          if (r) {
            const t = r.querySelectorAll("[data-option-value]");
            t.forEach((e) => {
              const r = (e.dataset.optionValue || "").toLowerCase().trim(),
                a = n.includes(r);
              if (
                ((e.style.display = a ? "" : "none"),
                !a && e.classList.contains("is-selected"))
              ) {
                (e.classList.remove("is-selected"),
                  e.setAttribute("aria-pressed", "false"));
                const r = Array.from(t).find((t) => {
                  const e = (t.dataset.optionValue || "").toLowerCase().trim();
                  return n.includes(e) && !t.disabled;
                });
                r && r.click();
              }
            });
          }
        }
        if (
          (t.addEventListener("variant:change", (e) => {
            const r = e.detail?.variant;
            if (!r) return;
            let n = -1;
            (t.querySelectorAll(".variant-tab-label").forEach((t, e) => {
              t.textContent.toLowerCase().includes("size") && (n = e);
            }),
              -1 !== n && r.options && r.options[n] && f(d(r.options[n])));
          }),
          t.querySelector(".variant-tab"))
        ) {
          const e = t.querySelectorAll(".variant-tab");
          let r = "";
          (e.forEach((t, e) => {
            const n = t.querySelector(".variant-tab-label");
            if (n && n.textContent.toLowerCase().includes("size")) {
              const e = t.querySelector("[data-tab-current]");
              e && (r = e.textContent.trim());
            }
          }),
            r && f(d(r)));
        }
      })(o),
      (function (t) {
        const e = t.querySelector("[data-button-option-panel]"),
          r = t.querySelector("[data-product-form]");
        if (!e || !r) return null;
        const n = Array.from(e.querySelectorAll("[data-button-option-choice]")),
          a = t.querySelector("[data-button-option-tab-current]");
        if (0 === n.length) return null;
        let o = r.querySelector('input[name="properties[Button Option]"]');
        o ||
          ((o = document.createElement("input")),
          (o.type = "hidden"),
          (o.name = "properties[Button Option]"),
          (o.value = ""),
          r.appendChild(o));
        let i = n.find((t) => t.classList.contains("is-selected")) || n[0];
        function s(t) {
          ((i = t || null),
            n.forEach((t) => {
              const e = t === i;
              (t.classList.toggle("is-selected", e),
                t.setAttribute("aria-pressed", String(e)));
            }));
          const r = (i && i.dataset.buttonOptionLabel) || "";
          (o && (o.value = r),
            a && ((a.textContent = r), a.setAttribute("title", r)));
          const s = e.closest("[data-product-section]");
          s &&
            s.dispatchEvent(
              new CustomEvent("button-option:change", { bubbles: !0 }),
            );
        }
        (n.forEach((t) => {
          t.addEventListener("click", () => {
            s(t);
          });
        }),
          s(i));
      })(o));
    const zt = (function (r, n = {}) {
      const a = r.querySelector("[data-mattress-toggle]"),
        o = r.querySelector("[data-mattress-overlay]"),
        i = r.querySelector("[data-mattress-drawer]"),
        s = r.querySelectorAll("[data-mattress-close]"),
        c = r.querySelector("[data-mattress-drawer-eyebrow]"),
        l = r.querySelector("[data-mattress-drawer-title]"),
        d = r.querySelector("[data-mattress-progress]"),
        u = Array.from(r.querySelectorAll("[data-mattress-dot]")),
        f = Array.from(r.querySelectorAll("[data-quiz-step]")),
        m = r.querySelector("[data-mattress-reco-title]"),
        p = r.querySelector("[data-mattress-size-label]"),
        g = r.querySelector("[data-mattress-results-list]"),
        h = r.querySelector("[data-product-form]");
      if (!(a && o && i && 0 !== f.length && g))
        return { hasSelection: () => !1, getSelectedVariantId: () => "" };
      const b =
          n.formatter ||
          t(
            document.documentElement.lang || "en-GB",
            r.dataset.currency || "GBP",
          ),
        y =
          "function" == typeof n.getCurrentVariant
            ? n.getCurrentVariant
            : () => null,
        v = [],
        S = { 1: 50, 2: 100 },
        w = {
          1: { eyebrow: "Find Your Perfect Mattress", title: "Quick question" },
          2: {
            eyebrow: "Your Matches",
            title: "Best results for your bed size",
          },
        },
        A = r.querySelector("#mattressTabEyebrow"),
        q = r.querySelector("#mattressTabHeadline"),
        E = r.querySelector("#mattressTabSub"),
        L = r.querySelector("#mattressTabChange"),
        x = {
          eyebrow: A ? A.textContent : "",
          headline: q ? q.textContent : "",
          subtitle: E ? E.textContent : "",
        };
      let k = { sleepers: null, position: null, feel: null, priority: null },
        C = 1,
        $ = [],
        N = null;
      const I = (function () {
          const t = Array.from(r.querySelectorAll(".variant-tab"));
          for (const e of t) {
            if (
              !(e.querySelector(".variant-tab-label")?.textContent || "")
                .toLowerCase()
                .includes("size")
            )
              continue;
            const t = Number(
              e.querySelector("[data-tab-current]")?.dataset.optionIndex,
            );
            if (Number.isFinite(t)) return t;
          }
          return -1;
        })(),
        M = D("properties[Mattress Add-on Variant ID]"),
        T = D("properties[Mattress Add-on]");
      function D(t) {
        if (!h) return null;
        let e = h.querySelector(`input[name="${t}"]`);
        return (
          e ||
            ((e = document.createElement("input")),
            (e.type = "hidden"),
            (e.name = t),
            (e.value = ""),
            h.appendChild(e)),
          e
        );
      }
      function P() {
        if (!N)
          return (
            M && (M.value = ""),
            T && (T.value = ""),
            void r.dispatchEvent(
              new CustomEvent("mattress:change", { bubbles: !0 }),
            )
          );
        (M && (M.value = String(N.variant.id || "")),
          T && (T.value = `${N.product.title} - ${N.variant.title}`),
          r.dispatchEvent(new CustomEvent("mattress:change", { bubbles: !0 })));
      }
      function z(t) {
        const e = String(t || "")
          .toLowerCase()
          .replace(/[()]/g, " ")
          .replace(/\s+/g, " ")
          .trim();
        return e
          ? /super\s*king|6\s*ft|6ft|180\s*x\s*200|6\s*'\s*0/.test(e)
            ? "super-king"
            : /small\s*single|2\s*ft\s*6|2ft6|75\s*x\s*190|2\s*'\s*6/.test(e)
              ? "small-single"
              : /small\s*double|4\s*ft\b(?!\s*6)|4ft\b(?!6)|120\s*x\s*190|4\s*'\s*0/.test(
                    e,
                  )
                ? "small-double"
                : /double|4\s*ft\s*6|4ft6|135\s*x\s*190|4\s*'\s*6/.test(e)
                  ? "double"
                  : /king|5\s*ft|5ft|150\s*x\s*200|5\s*'\s*0/.test(e)
                    ? "king"
                    : /single|3\s*ft|3ft|90\s*x\s*190|3\s*'\s*0/.test(e)
                      ? "single"
                      : ""
          : "";
      }
      function B() {
        const t = y();
        return t && Array.isArray(t.options)
          ? Number.isFinite(I) && I >= 0 && t.options[I]
            ? t.options[I]
            : t.options.find((t) => z(t)) || ""
          : "";
      }
      function O() {
        return z(B());
      }
      function V(t, e) {
        const r = Array.isArray(t.variants) ? t.variants : [];
        if (0 === r.length) return null;
        const n =
          {
            "small-single": ["small-single", "single"],
            single: ["single"],
            "small-double": ["small-double", "double"],
            double: ["double", "small-double"],
            king: ["king"],
            "super-king": ["super-king", "king"],
          }[e] || [];
        for (const t of n) {
          const e = r.find((e) => !!e.available && z(e.title) === t);
          if (e) return e;
        }
        return r.find((t) => t.available) || r[0] || null;
      }
      function H() {
        (o.classList.add("open"),
          i.classList.add("open"),
          (document.body.style.overflow = "hidden"),
          G(k.sleepers && k.position && k.feel && k.priority ? 5 : 1));
        const t = i.querySelector("[data-mattress-close]");
        t && setTimeout(() => t.focus(), 100);
      }
      function _() {
        (o.classList.remove("open"),
          i.classList.remove("open"),
          (document.body.style.overflow = ""),
          a && a.focus());
      }
      function F(t) {
        return e(b, t);
      }
      function R(t) {
        return String(t || "")
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#39;");
      }
      const W = {
          "dorchester-orthopedic-mattress": {
            feel: { soft: 1, medium: 3, firm: 5 },
            pressure: 2,
            back: 5,
            temp: 2,
            motion: 2,
            edge: 4,
          },
          "memory-deluxe-mattress": {
            feel: { soft: 4, medium: 4, firm: 2 },
            pressure: 5,
            back: 3,
            temp: 1,
            motion: 4,
            edge: 2,
          },
          "oxford-pillowtop-matress": {
            feel: { soft: 4, medium: 4, firm: 2 },
            pressure: 4,
            back: 3,
            temp: 3,
            motion: 2,
            edge: 3,
          },
          "backcare-1000-mattress": {
            feel: { soft: 1, medium: 2, firm: 5 },
            pressure: 2,
            back: 5,
            temp: 3,
            motion: 3,
            edge: 4,
          },
          "sapphire-pillowtop-2000-mattress": {
            feel: { soft: 4, medium: 4, firm: 2 },
            pressure: 5,
            back: 4,
            temp: 3,
            motion: 5,
            edge: 4,
          },
          "super-reflex-foam-mattress": {
            feel: { soft: 3, medium: 4, firm: 3 },
            pressure: 4,
            back: 4,
            temp: 1,
            motion: 4,
            edge: 3,
          },
          "dorset-pocket-1000-matress": {
            feel: { soft: 2, medium: 4, firm: 4 },
            pressure: 3,
            back: 4,
            temp: 3,
            motion: 3,
            edge: 3,
          },
          "swansea-2000-pocket-matress": {
            feel: { soft: 4, medium: 4, firm: 2 },
            pressure: 4,
            back: 3,
            temp: 3,
            motion: 5,
            edge: 4,
          },
          "tencel-1500-pocket-mattress": {
            feel: { soft: 3, medium: 4, firm: 3 },
            pressure: 3,
            back: 4,
            temp: 5,
            motion: 4,
            edge: 4,
          },
          "chester-wool-2000-pocket-mattress": {
            feel: { soft: 5, medium: 3, firm: 1 },
            pressure: 4,
            back: 3,
            temp: 5,
            motion: 5,
            edge: 4,
          },
          "mroydon-silk-1500-pocket-mattress": {
            feel: { soft: 3, medium: 4, firm: 3 },
            pressure: 3,
            back: 4,
            temp: 3,
            motion: 4,
            edge: 4,
          },
          "silk-memory-1000-mattress": {
            feel: { soft: 4, medium: 4, firm: 2 },
            pressure: 4,
            back: 3,
            temp: 2,
            motion: 3,
            edge: 3,
          },
          "backcare-2000-mattress": {
            feel: { soft: 1, medium: 2, firm: 5 },
            pressure: 3,
            back: 5,
            temp: 3,
            motion: 4,
            edge: 4,
          },
          "richmond-pillowtop-3000-pocket": {
            feel: { soft: 4, medium: 4, firm: 2 },
            pressure: 5,
            back: 4,
            temp: 3,
            motion: 5,
            edge: 5,
          },
          "oxford-mattress": {
            feel: { soft: 2, medium: 4, firm: 3 },
            pressure: 2,
            back: 3,
            temp: 3,
            motion: 2,
            edge: 3,
          },
          "supreme-2500-pocket-matress": {
            feel: { soft: 4, medium: 4, firm: 2 },
            pressure: 4,
            back: 4,
            temp: 3,
            motion: 5,
            edge: 4,
          },
          "luxury-waterproof-mattress": {
            feel: { soft: 2, medium: 3, firm: 3 },
            pressure: 3,
            back: 3,
            temp: 3,
            motion: 2,
            edge: 2,
            niche: !0,
          },
        },
        j = {
          feel: { soft: 2, medium: 3, firm: 2 },
          pressure: 2,
          back: 2,
          temp: 3,
          motion: 2,
          edge: 2,
        };
      function U(t) {
        return W[t.handle] || j;
      }
      function X(t) {
        ((C = t),
          f.forEach((e) => {
            const r = Number(e.dataset.quizStep) === t;
            e.classList.toggle("is-active", r);
          }),
          d && (d.style.width = `${S[t] || 0}%`),
          u.forEach((e) => {
            const r = Number(e.dataset.mattressDot);
            (e.classList.remove("is-active", "is-done"),
              r === t
                ? e.classList.add("is-active")
                : r < t && e.classList.add("is-done"));
          }));
        const e = w[t] || w[1];
        (c && (c.textContent = e.eyebrow), l && (l.textContent = e.title));
        const r = f.find((e) => Number(e.dataset.quizStep) === t);
        if (r && t < 2) {
          const t = r.querySelector("[data-quiz-answer]")?.dataset.quizAnswer,
            e = t ? k[t] : null;
          r.querySelectorAll("[data-quiz-answer]").forEach((t) => {
            t.classList.toggle("is-selected", t.dataset.quizValue === e);
          });
          const n = r.querySelector(".quiz-next");
          n && (n.disabled = !e);
        }
        2 === t && Z();
      }
      function G(t) {
        X(Math.max(1, Math.min(2, Number(t) || 1)));
      }
      function K(t, e, r) {
        const { product: n, variant: a } = t,
          o = Number(a.price || 0),
          i = Number(a.compareAtPrice || 0),
          s = i > o,
          c = s
            ? `<div class="pdp-save-price">Save ${F(s ? i - o : 0)}</div>`
            : "",
          l = s ? `<span class="mattress-price-was">Was ${F(i)}</span>` : "",
          d = r
            ? '<div class="mattress-match-badge">Top Match</div>'
            : `<div class="mattress-match-badge">Size: ${R(a.title)}</div>`,
          u = t.reasons && t.reasons.length > 0 ? t.reasons[0] : "",
          f = u
            ? `<div class="mattress-reason"><span class="mi" aria-hidden="true">check_circle</span><span>${R(u)}</span></div>`
            : "";
        return `\n        <div class="card-addons${e ? " is-selected" : ""}" data-product-id="${n.productId}" data-variant-id="${a.id}" data-mattress-handle="${R(n.handle)}">\n          <div class="card-body-mattress-drawer" data-mattress-option-card data-variant-id="${a.id}" data-mattress-handle="${R(n.handle)}">\n            <span class="add-plus-btn" aria-hidden="true">\n              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>\n              </svg>\n            </span>\n            <div class="image-card">\n              <img src="${R(n.image)}" alt="${R(n.title)}" height="80" width="86" loading="lazy">\n            </div>\n            <div class="card-details add-on">\n              <div class="mattress-card-title">${R(n.title)}</div>\n              ${f}\n              <div class="mattress-card-description">${R(
          (function (t) {
            const e = String(t || "")
              .replace(/\s+/g, " ")
              .trim();
            return e.length <= 100 ? e : `${e.slice(0, 97)}...`;
          })(n.description),
        )}</div>\n              <div class="card-pricing-details">\n                <div class="mattress-price-row">\n                  <span class="mattress-price-current">${F(o)}</span>\n                  ${l}\n                </div>\n                <div class="mattress-meta-row">\n                  ${d}\n                  ${c}\n                  <button\n                    type="button"\n                    class="mattress-see-details"\n                    data-mattress-see-details\n                    data-mattress-handle="${R(n.handle)}"\n                    data-mattress-url="/products/${R(n.handle)}"\n                  >See details</button>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      `;
      }
      function J() {
        const t = N ? String(N.variant.id) : "";
        g.querySelectorAll(".card-addons").forEach((e) => {
          const r = e.dataset.variantId === t;
          e.classList.toggle("is-selected", r);
        });
      }
      function Y() {
        if (!N)
          return (
            a.classList.remove("is-added"),
            a.setAttribute("aria-label", "Open mattress finder"),
            A && (A.textContent = x.eyebrow),
            q && (q.textContent = x.headline),
            E && (E.textContent = x.subtitle),
            void (L && L.classList.remove("is-visible"))
          );
        const { product: t, variant: e } = N,
          r = Number(e.compareAtPrice || 0),
          n = Number(e.price || 0),
          o = r > n;
        (a.classList.add("is-added"),
          a.setAttribute("aria-label", "Edit selected mattress"),
          A && (A.textContent = "Mattress selected"),
          q && (q.innerHTML = `<strong>${R(t.title)}</strong>`),
          E &&
            (E.textContent = o
              ? `${e.title} | ${F(n)} | Save ${F(r - n)}`
              : `${e.title} | ${F(n)}`),
          L && L.classList.add("is-visible"));
      }
      function Z() {
        const t = B() || "your selected size",
          e = O();
        p && (p.textContent = t);
        const r = v
          .map((t) => {
            const r = V(t, e);
            return r
              ? { product: t, variant: r, profile: U(t), reasons: [], score: 0 }
              : null;
          })
          .filter(Boolean);
        if (
          (r.forEach((t) => {
            t.score = (function (t) {
              const e = t.profile;
              let r = 0;
              const n = [];
              ("couple" === k.sleepers
                ? ((r += 3 * e.motion),
                  (r += 2 * e.edge),
                  e.motion >= 4
                    ? n.push("Great motion isolation")
                    : e.edge >= 4 && n.push("Strong edge support"))
                : "solo" === k.sleepers && (r += 2 * e.pressure),
                "side" === k.position
                  ? ((r += 4 * e.feel.soft),
                    (r += 3 * e.pressure),
                    e.feel.soft >= 4 &&
                      e.pressure >= 4 &&
                      n.push("Soft & cushioning for side sleepers"))
                  : "back" === k.position
                    ? ((r += 4 * e.feel.medium),
                      (r += 2 * e.back),
                      e.feel.medium >= 4 &&
                        e.back >= 4 &&
                        n.push("Balanced support for back sleepers"))
                    : "stomach" === k.position
                      ? ((r += 4 * e.feel.firm),
                        (r += 2 * e.back),
                        e.feel.firm >= 4 &&
                          n.push("Firm support for stomach sleepers"))
                      : "combo" === k.position &&
                        ((r += 4 * e.feel.medium), (r += 2 * e.motion)),
                k.feel && null != e.feel[k.feel] && (r += 5 * e.feel[k.feel]),
                "pressure" === k.priority
                  ? ((r += 6 * e.pressure),
                    e.pressure >= 4 && n.push("Excellent pressure relief"))
                  : "back" === k.priority
                    ? ((r += 6 * e.back),
                      e.back >= 4 && n.push("Excellent back support"))
                    : "cool" === k.priority &&
                      ((r += 8 * e.temp),
                      e.temp >= 4 && n.push("Cool & breathable")),
                e.niche && (r -= 30));
              const a = Math.max(
                0,
                3 - Math.floor(Number(t.variant.price || 0) / 2e4),
              );
              return ((t.reasons = n), 100 * r + a);
            })(t);
          }),
          r.sort((t, e) => {
            if (e.score !== t.score) return e.score - t.score;
            const r =
              Number(t.variant.price || 0) - Number(e.variant.price || 0);
            return 0 !== r
              ? r
              : String(t.product.title).localeCompare(String(e.product.title));
          }),
          ($ = r),
          0 === $.length)
        )
          return (
            m && (m.textContent = "No mattresses found for this size yet."),
            void (g.innerHTML =
              '<p class="text-gray fs-sm">No mattress matches are currently available for this size.</p>')
          );
        const n = $[0];
        (m && (m.textContent = `${n.product.title} - ${n.variant.title}`),
          (N = { product: n.product, variant: n.variant }));
        const a = (t) =>
            N &&
            N.product.handle === t.product.handle &&
            Number(N.variant.id) === Number(t.variant.id),
          o = `\n        <div class="mattress-result-group mattress-result-group--top">\n          <div class="mattress-result-group-label">\n            <span class="mi" aria-hidden="true">stars</span>\n            <span>Recommended for you</span>\n          </div>\n          ${K(n, a(n), !0)}\n        </div>\n      `,
          i = $.slice(1),
          s =
            0 === i.length
              ? ""
              : `\n          <div class="mattress-result-group mattress-result-group--others">\n            <div class="mattress-result-group-label mattress-result-group-label--others">Other options</div>\n            ${i.map((t) => K(t, a(t), !1)).join("")}\n          </div>\n        `;
        ((g.innerHTML = o + s),
          g.querySelectorAll("[data-mattress-option-card]").forEach((t) => {
            t.addEventListener("click", () => {
              const e = Number(t.dataset.variantId),
                r = t.dataset.mattressHandle || "",
                n = $.find(
                  (t) =>
                    String(t.product.handle) === String(r) &&
                    Number(t.variant.id) === e,
                );
              n &&
                (function (t) {
                  ((N = { product: t.product, variant: t.variant }),
                    J(),
                    P(),
                    Y());
                })(n);
            });
          }),
          g.querySelectorAll("[data-mattress-see-details]").forEach((t) => {
            t.addEventListener("click", (e) => {
              (e.preventDefault(), e.stopPropagation());
              const r = t.dataset.mattressUrl;
              r && window.open(r, "_blank", "noopener");
            });
          }),
          P(),
          Y(),
          J());
      }
      return (
        a.addEventListener("click", (t) => {
          const e = a.querySelector(".mattress-tab-arrow");
          if (
            e &&
            (t.target === e || e.contains(t.target)) &&
            a.classList.contains("is-added")
          )
            return (t.stopPropagation(), (N = null), P(), Y(), void J());
          H();
        }),
        "undefined" != typeof window &&
          window.location &&
          "#mattressTab" === window.location.hash &&
          requestAnimationFrame(() => {
            try {
              (a.scrollIntoView({ behavior: "smooth", block: "center" }), H());
            } catch (t) {
              H();
            }
          }),
        s.forEach((t) => {
          t.addEventListener("click", _);
        }),
        o.addEventListener("click", _),
        i.addEventListener("keydown", (t) => {
          if ("Escape" !== t.key) {
            if ("Tab" === t.key) {
              const e = Array.from(
                i.querySelectorAll(
                  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
                ),
              ).filter((t) => !t.disabled && null !== t.offsetParent);
              if (0 === e.length) return;
              const r = e[0],
                n = e[e.length - 1];
              t.shiftKey && document.activeElement === r
                ? (t.preventDefault(), n.focus())
                : t.shiftKey ||
                  document.activeElement !== n ||
                  (t.preventDefault(), r.focus());
            }
          } else _();
        }),
        i.querySelectorAll("[data-quiz-answer]").forEach((t) => {
          t.addEventListener("click", () => {
            const e = t.closest("[data-quiz-step]");
            if (!e) return;
            const r = t.dataset.quizAnswer,
              n = t.dataset.quizValue;
            if (!r) return;
            ((N = null),
              P(),
              Y(),
              (k[r] = n),
              e.querySelectorAll(`[data-quiz-answer="${r}"]`).forEach((t) => {
                t.classList.remove("is-selected");
              }),
              t.classList.add("is-selected"));
            const a = e.querySelector(".quiz-next");
            a && (a.disabled = !1);
          });
        }),
        i.querySelectorAll("[data-quiz-next]").forEach((t) => {
          t.addEventListener("click", () => {
            const e = Number(t.dataset.quizNext || 0);
            e && G(e);
          });
        }),
        i.querySelectorAll("[data-quiz-back]").forEach((t) => {
          t.addEventListener("click", () => {
            const e = Number(t.dataset.quizBack || 0);
            e && G(e);
          });
        }),
        r.addEventListener("variant:change", () => {
          ((function () {
            if (!N) return;
            const t = V(N.product, O());
            t && ((N = { product: N.product, variant: t }), P(), Y(), J());
          })(),
            2 === C && i.classList.contains("open")
              ? Z()
              : p && (p.textContent = B() || "your selected size"));
        }),
        P(),
        Y(),
        X(1),
        {
          hasSelection: () => Boolean(N && N.variant && N.variant.id),
          getSelectedVariantId: () =>
            N && N.variant ? String(N.variant.id || "") : "",
          open: H,
          close: _,
        }
      );
    })(o, {
      formatter: y,
      getCurrentVariant() {
        const t = String(b.value || "");
        return m.find((e) => String(e.id) === t) || ut;
      },
    });
    (Tt(),
      l.addEventListener("submit", async (t) => {
        if (W) return;
        t.preventDefault();
        const e = (function () {
            if (l.isConnected) return l;
            if (A) {
              const t = document.querySelector(
                `[data-product-section][data-section-id="${A}"] [data-product-form]`,
              );
              if (t instanceof HTMLFormElement) return t;
            }
            return l;
          })(),
          r = e.querySelector('input[name="id"]'),
          n = await (async function () {
            (await pt, At());
            const t = String(b.value || "").trim();
            if ((p && !L && (await ht(p), At()), Array.isArray(ft))) {
              const e = m.find((e) => String(e.id) === t);
              if (e && Array.isArray(e.options))
                for (let t = 0; t < e.options.length; t++)
                  "" === String(ft[t] || "").trim() && (ft[t] = e.options[t]);
            }
            let e =
              vt(ft) ||
              (function (t) {
                let e = null,
                  r = -1;
                for (const n of m) {
                  if (!n.available || !Array.isArray(n.options)) continue;
                  let a = 0,
                    o = !0;
                  for (let e = 0; e < n.options.length; e++) {
                    const r = t[e];
                    if ("" !== String(r || "").trim()) {
                      if (!yt(r, n.options[e])) {
                        o = !1;
                        break;
                      }
                      a++;
                    }
                  }
                  o && a > r && ((r = a), (e = n));
                }
                return e;
              })(ft);
            return (
              !e && t && (e = m.find((e) => String(e.id) === t) || null),
              !e && t && v
                ? { id: Number(t) }
                : e
                  ? (Array.isArray(e.options) &&
                      ((ft = e.options.slice()), qt(), Et(), xt()),
                    Dt(e),
                    Y(e.id),
                    e)
                  : null
            );
          })(),
          a = Number(n && n.id ? n.id : 0),
          i = Number((j && j.hasSelection() && j.getSelectedVariantId()) || 0),
          s = Number(
            (zt && zt.hasSelection() && zt.getSelectedVariantId()) || 0,
          ),
          c =
            U && "function" == typeof U.getSelectedItems
              ? U.getSelectedItems()
              : [],
          d = Math.max(
            1,
            Number(l.querySelector('input[name="quantity"]')?.value || 1),
          ),
          u = Boolean(i || s || c.length > 0);
        if (a) {
          r && (r.value = String(a));
          Pt(!0);
          try {
            const t = (function (t = l) {
                const e = {},
                  r = t instanceof HTMLFormElement ? t : l,
                  n = new FormData(r);
                for (const [t, r] of n.entries()) {
                  if (!t.startsWith("properties[") || !t.endsWith("]"))
                    continue;
                  const n = t.slice(11, -1),
                    a = String(r || "").trim();
                  n && a && (e[n] = a);
                }
                return e;
              })(e),
              r = u
                ? `bundle-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
                : "",
              n = u ? { ...t, _bundle_id: r, _bundle_role: "main" } : t,
              checkoutItems = [{ id: a, quantity: d, properties: n }];
            const warrantyProductType = String(o.dataset.productTypeName || "").trim().toLowerCase(),
              warrantyEligible = [
                "divan beds",
                "upholstered beds",
                "kids beds",
                "ottoman storage beds",
                "tv bed",
                "tv beds",
                "luxury headboards",
                "mattresses",
                "headboards",
              ].includes(warrantyProductType);
            warrantyEligible &&
              checkoutItems.push({
                id: 54045958537545,
                quantity: 1,
                properties: {
                  _bundle_id: r,
                  _bundle_role: "service",
                  _warranty_promo: "Extend5Y",
                  "Warranty cover": "Upgraded to 10 years total",
                  "Included value": "Free £150 10-year warranty upgrade with Extend5Y",
                },
              });

            i &&
              checkoutItems.push({
                id: i,
                quantity: d,
                properties: { _bundle_id: r, _bundle_role: "storage" },
              });
            s &&
              checkoutItems.push({
                id: s,
                quantity: d,
                properties: { _bundle_id: r, _bundle_role: "mattress" },
              });
            c.forEach((t) => {
              const e = Number(t.variantId || 0);
              e &&
                checkoutItems.push({
                  id: e,
                  quantity: d,
                  properties: { _bundle_id: r, _bundle_role: "service" },
                });
            });

            const checkoutResponse = await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({ items: checkoutItems }),
            });
            if (!checkoutResponse.ok)
              throw new Error("Failed to add the configured items");

            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", { bubbles: !0 }),
            );
            window.location.assign("/discount/Extend5Y?redirect=/checkout");
          } catch (t) {
            console.error("Could not start checkout:", t);
            const e = o.querySelector("[data-atc-toast]");
            e &&
              ((e.textContent =
                "Could not start checkout. Please check your selections and try again."),
              e.classList.remove("is-success"),
              (e.hidden = !1),
              setTimeout(() => {
                e.hidden = !0;
              }, 6e3));
          } finally {
            Pt(!1);
          }
        }
      }),
      o.addEventListener("storage:change", () => {
        const t = String(b.value || ""),
          e = m.find((e) => String(e.id) === t);
        e ? (Dt(e), Tt()) : It().then(() => Tt());
      }),
      o.addEventListener("service:change", () => {
        const t = String(b.value || ""),
          e = m.find((e) => String(e.id) === t);
        e ? (Dt(e), Tt()) : It().then(() => Tt());
      }),
      o.addEventListener("variant:change", Tt),
      o.addEventListener("button-option:change", Tt),
      o.addEventListener("mattress:change", Tt));
  }
  function c(t) {
    t.querySelectorAll("[data-fabric-tabs]").forEach((t) => {
      const e = t.querySelectorAll("[data-fabric-tab]"),
        r = t.closest(".variant-panel, [data-product-color-options]");
      if (!r) return;
      const n = r.querySelectorAll("[data-fabric-panel]");
      e.forEach((t) => {
        t.addEventListener("click", () => {
          const r = t.dataset.fabricTab;
          (e.forEach((e) => {
            const r = e === t;
            (e.classList.toggle("is-active", r),
              e.setAttribute("aria-pressed", String(r)));
          }),
            n.forEach((t) => {
              t.dataset.fabricPanel === r
                ? t.classList.add("is-active")
                : t.classList.remove("is-active");
            }));
        });
      });
    });
  }
  var l;
  ("scrollRestoration" in history && (history.scrollRestoration = "manual"),
    window.addEventListener("wishlist:updated", function (t) {
      const e = document.querySelector("[data-product-section]");
      e &&
        e
          .querySelectorAll(
            "[data-wishlist-btn], [data-wishlist-btn-secondary]",
          )
          .forEach((t) => {
            const e = t.dataset.productId;
            e && i(t, e);
          });
    }),
    (l = () => {
      (r(document),
        a(document),
        c(document),
        document.querySelectorAll("[data-product-section]").forEach((t) => {
          s(t);
        }));
    }),
    "loading" !== document.readyState
      ? l()
      : document.addEventListener("DOMContentLoaded", l));
})();
